var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, comma, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    if (comma == false) dollars = dollars.replace(/,/g, ' ');

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0, false);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, true, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, true, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};






class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = () => this.callbacks.forEach(cb => cb());
  }

  addScrollListener(instance, func) {
    const key = `${instance.constructor.name}_${func.name}_${++this.listenerIdCounter}`.replace(/ /g, '_');
    this.callbacks.set(key, func.bind(instance));

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => {
        this.callbacks.delete(key);
        if (!this.callbacks.size && this.isListening) {
          window.removeEventListener("scroll", this.boundRunCallbacks);
          this.isListening = false;
        }
        return null;
      }
    };
  }
}

const scrollListener = new GlobalScrollListener();


class InfiniteScroll {
  constructor(container, paginationElement, restoreState) {
    if (
      !document.querySelector(container) ||
      !document.querySelector(paginationElement)
    )
      return;

    this.containerSelector = container;
    this.paginationElementSelector = paginationElement;
    this.restoreState = restoreState;
    this.treshold = 650;
    this.domDelegate = new Delegate(document.body);
    this.mainContainer = document.querySelector(this.containerSelector);
    this.loadType = this.mainContainer.dataset.load;
    this.running = false;
    this.bindEvents();

    const pageAccessedByReload = window.performance
      .getEntriesByType("navigation")
      .some((entry) => entry.type === "reload");

    if (
      this.restoreState &&
      sessionStorage.getItem("pageState") > 1 &&
      window.location.href === sessionStorage.getItem("pageStateURL") &&
      !pageAccessedByReload
    ) {
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.initObserver();
    }
  }

  initObserver() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    this.observer = new IntersectionObserver(
      this.handleIntersect.bind(this),
      observerOptions
    );
    this.observer.observe(this.mainContainer);
  }

  bindEvents() {
    this.handleClickBinder = this.handleClick.bind(this);
    this.handleScrollBinder = this.handleScroll.bind(this);

    if (this.restoreState) {
      window.addEventListener(
        "beforeunload",
        this.rememberCurrentState.bind(this)
      );
    }
  }

  rememberCurrentState() {
    const scrollPositionY = window.scrollY;
    const currentUrl = window.location.href;
    const currentPage = document.querySelector(this.paginationElementSelector)?.dataset.page;

    sessionStorage.setItem("pageState", currentPage);
    sessionStorage.setItem("pageStateURL", currentUrl);
    sessionStorage.setItem("pageStateScroll", scrollPositionY);
  }

  initialize() {
    if (this.loadType === "scroll") {
      this.scrollListener = scrollListener.addScrollListener(
        this,
        this.handleScrollBinder
      );
    } else {
      this.domDelegate.on(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  destroy() {
    if (this.loadType === "scroll") {
      this.scrollListener?.removeScrollListener();
    } else {
      this.domDelegate.off(
        "click",
        `${this.paginationElementSelector} [data-action="load"]`,
        this.handleClickBinder
      );
    }
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (this.running === false) {
          this.initialize();
          this.running = true;
        }
      } else {
        this.running = false;
        this.destroy();
      }
    });
  }

  handleScroll() {
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;

    const top =
      this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom =
      this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector("a");

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  handleClick(e) {
    e.preventDefault();
    e.target
      .closest("a")
      .querySelector(".itemLoader")
      .classList.add("is-visible");

    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );
    if (!this.paginationElement) return;
    this.nextPageLinkElement = this.paginationElement.querySelector("a");

    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;
      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];

    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem("pageState"));
      for (let i = 2; i <= limit; i++) {
        let url;

        // Build the URL based on the condition
        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(
          fetch(url, {
            credentials: "same-origin",
            method: "GET",
          })
        );
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(
        fetch(url, {
          credentials: "same-origin",
          method: "GET",
        })
      );
    }

    return promises;
  }

  async renderData(promises, restoreContent) {
    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(
        responses.map((response) => response.text())
      );
      let isLastPromise = false;
      contents.forEach((content, index) => {
        isLastPromise = index === contents.length - 1;
        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error("Error fetching or parsing data:", error);
    }
  }

  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");
    const contentToAdd = doc.querySelector(this.containerSelector);

    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement = document.querySelector(
      this.paginationElementSelector
    );

    if (this.paginationElement) {
      this.paginationElement.remove();
    }

    this.mainContainer.insertAdjacentHTML("beforeend", contentToAdd.innerHTML);

    if (lastPromise) {
      this.initialize();
    }

    if (lastPromise && restoreContent) {
      this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );

    document.dispatchEvent(new CustomEvent('update-favorites'));

    new RevolutionAnimation(this.mainContainer);
  }

  restoreScroll() {
    const scrollPosition = parseInt(sessionStorage.getItem("pageStateScroll"));

    if (scrollPosition) {
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  }
}

class Responsive {
  constructor(enableGeneralBreakpointChange, trackWindowHeight) {
    this.settings();

    this.trackWindowHeight = trackWindowHeight;
    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.setWindowHeight();
    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)",
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      pocket: "(max-width: 1024px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      desktop: "(min-width: 1025px)",
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(
          new CustomEvent("breakpoint:changed", {
            detail: {
              previousBreakpoint: this.currentBreakpoint,
              currentBreakpoint: newBreakpoint,
            },
          })
        );
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(
          new CustomEvent(`breakpoint:${key}`, {
            detail: {
              matches: isCurrentlyInBreakpoint,
            },
          })
        );
      }
    });

    this.currentBreakpoint = newBreakpoint;

    this.setWindowHeight();

    // Run additional registered resize callbacks
    this.runCallbacks();
  }

  setWindowHeight() {
    if (this.trackWindowHeight) {
      document.documentElement.style.setProperty(
        "--window-height",
        `${window.innerHeight}px`
      );
    }
  }

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, "_"); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key),
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach((callback) => callback());
  }
}

const responsive = new Responsive(false, true);


class dynamicVariables {
  constructor() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    document.documentElement.style.setProperty(
      "--ivh",
      `${window.innerHeight}px`
    );

    responsive.addResizeListener(this, this.sync.bind(this));
  }


  sync() {
    this.syncWidth();
    this.syncHeight();
  }

  syncWidth() {
    document.documentElement.style.setProperty(
      "--viewport_width",
      `${document.documentElement.clientWidth}px`
    );

  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  }


}

const dynamicVars = new dynamicVariables();

let eventPopup = false;
class Popup {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.domDelegate = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.addedScrollLock = false;
    this.bindEvents();
  }
  bindEvents() {
    if (eventPopup === false) {
      this.domDelegate.on(
        "click",
        '[data-action="open-modal"]',
        this.openModal.bind(this)
      );
      eventPopup = true;

      this.domDelegate.on(
        "click",
        '[data-action="close-modal"]',
        this.closeModal.bind(this)
      );
      this.domDelegate.on(
        "click",
        '[data-action="add-to-cart"]',
        this.closeModal.bind(this)
      );
    }
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );
    this.domDelegate.on(
      "close:other",
      this.closeModal.bind(this)
    );

    this.domDelegate.on("popup:close", this.closeModal.bind(this));
    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal(event) {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    if (responsive.matchesBreakpoint('lap_and_up')) {
      this.element.dispatchEvent(
        new CustomEvent("close:other", { bubbles: true })
      );
    }

    this.activeModal = document.getElementById(
      event.target.closest("[aria-controls]").getAttribute("aria-controls")
    );


    if (!this.activeModal) return;
    if (this.activeModal.id.includes("product-card-popup")) {
      if (event.target.getAttribute("data-action") != "select-change") {
        this.element.dispatchEvent(
          new CustomEvent("popup:opened", {
            bubbles: true,
            detail: {
              product: event.target.dataset.productId,
              product_variants: JSON.parse(
                event.target.querySelector('[type="application/json"]')
                  .textContent
              ),
            },
          })
        );
      }

    }

    this.activeModal.style.display = "block";
    requestAnimationFrame(() => {
      this.activeModal.offsetHeight;
      this.activeModal.setAttribute("aria-hidden", "false");
    });


    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );

    var focus = this.activeModal.querySelector("[data-scrollable]");
    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);

    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    if (document.body.classList.contains("scrollLock") == false) {
      this.addedScrollLock = true;
      document.body.classList.add("scrollLock");
    }
  }

  calculateHeight(el) {
    const headerHeight =
      this.element.querySelector(".popup--header").offsetHeight;
    const maxHeight = 338 - headerHeight;
    const realScrollableHeight =
      this.element.querySelector("[data-scrollable]");

    if (realScrollableHeight.scrollHeight > maxHeight) {
      realScrollableHeight.style.height = `${maxHeight}px`;
    }
  }

  openModalSpecial(event) {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");

    let focus = this.element.querySelector("[data-scrollable]");
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );

    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");
    trapFocus(this.activeModal);
  }


  closeModal() {
    event.preventDefault();
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );
    if (!this.activeModal) return;
    if (this.addedScrollLock == true) {
      document.body.classList.remove("scrollLock");
      this.addedScrollLock = false;
    }



    if (this.activeModal.id == 'modal-country') {
      this.pageOverlayElement = document.querySelector(".localizationOverlay");
      if (!this.pageOverlayElement.classList.contains("is-visible")) {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }

    setTimeout(() => {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );

      bodyScrollLock.enableBodyScroll(this.activeModal.querySelector('[data-scrollable]'));

    }, 300)

    this.activeModal.setAttribute("aria-hidden", "true");

    const productCardPopup = document.getElementById("product-card-popup");
    const modalHeight = window.innerHeight - 32;
    if (this.element.getAttribute("id") == "product-card-popup") {
      requestAnimationFrame(() => {
        if (productCardPopup.offsetHeight > modalHeight) {
          productCardPopup.style.height = `${modalHeight}px `;
        }
      });
    }
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
    this.applyColorScheme();
  }

  applyColorScheme() {
    const productModule = document.querySelector('.product-module');
    const colorGroupClass = Array.from(productModule.classList).find(className => className.includes('colorGroup'));
    document.querySelector('.pswp').classList.add(colorGroupClass);
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    responsive.addResizeListener(this, this.syncHeight.bind(this));
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "click",
      ".product-module__product-slider--image",
      this.initPhotoSwipeFromImageClick.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );

    this.onPointerUpBinder = this.onPointerUp.bind(this);
    this.onPointerDownBinder = this.onPointerDown.bind(this);
    responsive.addBreakpointListener("lap_and_up");
    this.delegateRoot.on(
      "breakpoint:lap_and_up",
      this.toggleMoveZoom.bind(this)
    );
    this.toggleMoveZoom();

    if (responsive.matchesBreakpoint('pocket') && document.querySelector('[data-zoom-type="image"]')) {
      this.delegateElement.on(
        "click",
        '.product-module__product-slider--image',
        this.initPhotoSwipeFromPhotoTap.bind(this)
      );
    }
  }

  toggleMoveZoom(e) {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.delegateRoot.on(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.on("pointerup", "[data-move]", this.onPointerUpBinder);
    } else {
      this.delegateRoot.off(
        "pointerdown",
        "[data-move]",
        this.onPointerDownBinder
      );
      this.delegateRoot.off("pointerup", "[data-move]", this.onPointerUpBinder);
    }
  }

  onPointerDown(e) {
    this.timeout = setTimeout(() => {
      e.target.closest(".pswp__container")?.classList.add("move");
    }, 50);
  }

  onPointerUp(e) {
    if (this.timeout) {
      clearInterval(this.timeout);
    }
    e.target.closest(".pswp__container")?.classList.remove("move");
  }

  photoswiperClose() {
    if (this.photoSwipeInstance) {
      this.photoSwipeInstance.close;
    }
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  sortImageArray(images) {
    return images.sort((a, b) => {
      const positionA = parseInt(a.closest(".product-module__product-slider-element").getAttribute("data-image-position"));
      const positionB = parseInt(b.closest(".product-module__product-slider-element").getAttribute("data-image-position"));
      return positionA - positionB;
    });
  }

  initPhotoSwipeFromPhotoTap(e) {
    if (e.target.closest('[data-action="open-product-zoom"]') || e.target.closest('.product-module__product-highlight')) return;
    e.target.closest('.product-module__product-slider-cell').querySelector('[data-action="open-product-zoom"]').click();
  }

  initPhotoSwipe(event, target) {
    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.querySelectorAll('.product-module__product-slider-cell').forEach(function (item) {
        if (
          item.classList.contains("product-module__product-slider-cell--zoom")
        ) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
    } else {
      images.push(
        document.querySelector(".product-module__product-slider-image")
      );
    }

    const imagePosition = parseInt(
      target
        .nextElementSibling
        .getAttribute("data-image-position")
    );

    images = this.sortImageArray(images);

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(imagePosition)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (
      responsive.matchesBreakpoint("pocket") ||
      event.target.closest(".product-module__product-highlight")
    ) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    var images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (
        item.classList.contains("product-module__product-slider-cell--zoom") &&
        item.querySelector("img")
      ) {
        images.push(item.querySelector("img"));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(
      target
        .querySelector(".product-module__product-slider-element")
        .getAttribute("data-image-position")
    );

    images = this.sortImageArray(images);

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      imagePosition
    );
  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = responsive.matchesBreakpoint("pocket") ? 1200 : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {
    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".product-module__product-slider-cell--zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      (e) => {
        this.photoSwipeInstance.prev();
        e.target.classList.add('scale-animation');
        setTimeout(() => {
          e.target.classList.remove("scale-animation");
        }, 200);
      }
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      (e) => {
        this.photoSwipeInstance.next();
        e.target.classList.add('scale-animation');
        setTimeout(() => {
          e.target.classList.remove("scale-animation");
        }, 200);
      }
    );
    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );
    this.languageSelector = this.element.classList.contains(
      "RevolutionSelectbox--Selectors"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
      ".RevolutionSelectbox--Button"
    );

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {
        this.pageOverlayElement = document.querySelector(
          ".localizationOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }
    this.bindEvents();
    if (!this.element.classList.contains("dropdownSelector")) {
      this.initSelectbox();
    } else {
      this.element.style.display = "block";
    }
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action=toggle-selectbox]",
      this.toggleDropdown.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.delegateBody.on("topbar:slideoff", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));


    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
  }

  selectboxChange(event) {
    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");

    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
    } else {
      selEl.value = value;
    }

    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML = innerContent;

    if (this.element.classList.contains("dropdownSelector")) {
      const selectedItem = this.element.querySelector('.RevolutionSelectbox--Item[selected="selected"]');
      if (selectedItem) {
        selectedItem.removeAttribute("selected");
      }
      event.target.setAttribute("selected", "selected");
    }

    if (event.target.dataset.selectboxid == 'country-selector__country-code' || event.target.dataset.selectboxid === 'country-selector__language_code') {
      this.element.dispatchEvent(
        new CustomEvent("change:countrySelector", {
          bubbles: true,
          detail: {
            currency: event.target.dataset.currency,
            country: event.target.dataset.value,
            languages: event.target.dataset.languages
          },
        })
      );

      const selectboxContainer = event.target.closest(".RevolutionSelectbox--InnerContent");
      const selectedItem = selectboxContainer.querySelector('.RevolutionSelectbox--Item[selected="selected"]');
      if (selectedItem) {
        selectedItem.removeAttribute("selected");
      }
      event.target.setAttribute("selected", "selected");
    }
    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }

    var value = event.target.closest("[data-value]").getAttribute("data-value");
    var dataName = event.target
      .closest("[data-name]")
      .getAttribute("data-name");
    this.selectbox.value = value;

    this.closeDropdown(this.element);

    this.element.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;

    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    if (!this.mainDropdown) return;
    const selectedItem = this.mainDropdown.querySelector(
      '[selected="selected"]'
    ),
      titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem && this.connectedSelect != 'country_code') {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event, target) {
    event.preventDefault();

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    // Dispatch "menu:close" event on the element.
    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    if (this.changeOverlay) {
      var focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
    }

    // Find all siblings with class ".RevolutionSelectbox".
    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    // Hide the dropdown content for all siblings.
    siblings.forEach((item) => {
      item
        .querySelector(".RevolutionSelectbox--Button")
        .setAttribute("aria-expanded", false);
      item
        .querySelector(".RevolutionSelectbox--Content")
        .setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display =
        "none";
    });

    // If the dropdown is a popover, show the page overlay and disable body scrolling.
    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      const headerOverlay = document.querySelector(".header-overlay");
      if (headerOverlay) {
        headerOverlay.classList.add("is-visible");
      }
      this.pageOverlayElement.addEventListener(
        "click",
        this.onClickOutsideListener
      );

      trapFocus(this.mainDropdown);
    }

    if (this.element.closest("#modal-country")) {
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
    }

    // Show the dropdown content for the target element and set its state to "expanded".
    const contentElement = target.parentElement.querySelector(
      ".RevolutionSelectbox--Content"
    );
    contentElement.style.display = "block";
    contentElement.style.visibility = 'hidden';


    requestAnimationFrame(() => {
      contentElement.style.height = '';
      const height = contentElement.offsetHeight;
      contentElement.style.height = '0';
      contentElement.style.visibility = 'visible';
      requestAnimationFrame(() => {
        contentElement.style.height = `${height}px`;
      });
    });


    requestAnimationFrame(() => {
      target.setAttribute("aria-expanded", "true");
    });

    if (this.popover) {
      requestAnimationFrame(() => {
        contentElement.setAttribute("aria-hidden", "false");
      });
    } else {
      contentElement.setAttribute("aria-hidden", "false");
    }

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
  }

  closeDropdown(target) {
    if (this.isOpen == false) { return; }
    if (this.changeOverlay) {
      var focus = this.element.querySelector("[data-scrollable]");
      document.body.classList.remove("scrollLock");
      bodyScrollLock.enableBodyScroll(focus, bodyScrollLockOptions);
    }

    var closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      var closestDropdown = target.querySelector(
        "[aria-expanded='true']"
      ).parentElement;
    }
    closestDropdown
      .querySelector(".RevolutionSelectbox--Button")
      .setAttribute("aria-expanded", false);
    closestDropdown
      .querySelector(".RevolutionSelectbox--Content")
      .setAttribute("aria-hidden", true);
    closestDropdown.querySelector(
      ".RevolutionSelectbox--Content"
    ).style.height = "0px";
    setTimeout(() => {
      closestDropdown.querySelector(
        ".RevolutionSelectbox--Content"
      ).style.display = "none";
    }, 301);

    if (this.keydownListener) {
      window.removeEventListener("keydown", this.keydownListener);
      this.keydownListener = null;
    }

    if (this.popover == true) {
      this.pageOverlayElement.classList.remove("is-visible");
      const headerOverlay = document.querySelector(".header-overlay");
      if (headerOverlay) {
        headerOverlay.classList.remove("is-visible");
      }
      this.pageOverlayElement.removeEventListener(
        "click",
        this.onClickOutsideListener
      );
    }

    if (this.element.closest("#modal-country") && responsive.matchesBreakpoint('pocket')) {
      const focus = this.element.querySelector("[data-scrollable]");
      document.body.classList.remove("scrollLock");
      bodyScrollLock.enableBodyScroll(focus);
    }

    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }
}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      "[data-action=add-to-cart]",
      this.addToCart.bind(this)
    );
    this.delegateElement.on(
      "click",
      "[data-action=add-all-to-cart]",
      this.addAllToCart.bind(this)
    );
  }

  addAllToCart(event) {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = "100%";
    addToCartButton.setAttribute("disabled", "disabled");

    let bundleId = Date.now().toString();

    if (addToCartButton.classList.contains('add-all')) {
      document.querySelector('variant-selects')?.selectBaseCoatInstead();
      bundleId = null;
    }
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");

    var formHelper = new Form();
    let serialized = formHelper.serialize(formElement);

    let additionalInputs = Array.from(formElement.querySelectorAll('[name="id"]'))
      .filter(input => !input.hasAttribute('data-original'))
      .map((input, index) => {
        const hasBundleId = input.hasAttribute('data-bundle-id');
        const inputData = {
          id: input.value,
          quantity: input.dataset.quantity || 1
        };

        if (hasBundleId) {
          inputData.properties = {
            _title: document.querySelector('input[data-area]').dataset.area + " " + document.querySelector('.area__option-input:checked').dataset.value + " " + window.theme.bundle,
            _area: convertedArea,
            _unit: document.querySelector('.calculator__input-unit').value.trim(),
            _bundle_id: input.dataset.bundleId.replace('randomize', bundleId).replace('count', index)
          };
        }

        return inputData;
      });

    // Append additional products to serialized cart data
    serialized.items = additionalInputs;
    if (!addToCartButton.classList.contains('add-all')) {
      serialized.quantity = 0;
    }

    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(response => {
      if (response.ok) {
        if (window.theme.cartMode === 'page') {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        let variants = serialized.items.map(item => item.id);
        if (serialized.id && addToCartButton.classList.contains('add-all')) {
          variants.push(serialized.id);
        }

        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: variants,
              quantity: serialized.items.reduce((sum, item) => sum + parseInt(item.quantity), 0),
              bundle_id: bundleId
            },
          })
        );
      } else {
        response.json().then(content => {
          let errorContainer = _this.element.querySelector(".ProductForm--Error");
          if (errorContainer) {
            errorContainer.classList.add("visible");
            setTimeout(() => errorContainer.classList.remove("visible"), 3500);
          } else {
            let errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
            setTimeout(() => {
              errorMessageElement.remove();
              _this.element.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: true,
                  detail: {
                    variant: serialized.items.map(item => item.id), // Send all IDs
                    quantity: serialized.items.reduce((sum, item) => sum + parseInt(item.quantity), 0),
                    bundle_id: bundleId
                  },
                })
              );
            }, 3500);
          }
          _this.pageLoader.style.width = "0%";
        });
      }
    });
  }


  addToCart() {
    var _this = this;
    event.preventDefault();
    var addToCartButton = event.target;
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");
    var formElement = event.target.closest("form");
    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);
    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        if (window.theme.cartMode === 'page') {
          location.href = window.routes.cart_page_url;
        }
        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 3500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 3500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }
}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    first.focus();
  } else {
    elementToFocus.focus();
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

//Adds padding to sticky sidepanel on FAQ, Contact, Blog and T&C pages
function stickyLinksTopPadding() {
  const linkList = document.querySelector(".sidebar-panel__wrapper");
  if (linkList) {
    const isSticky = linkList.getBoundingClientRect().top === 0;

    if (isSticky) {
      linkList.style.paddingTop = "1.5rem";
    } else {
      linkList.style.paddingTop = "0rem";
    }
  }
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.lock = false;
    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {
      case "desktop":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  }

  updateAllDropdowns() {
    this.allDropdowns = document.querySelectorAll(".Dropdown");
  }

  openDropdown(elem, target) {
    if (this.lock) return;
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown, true);
      }
    });

    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    DropdownButton.setAttribute("aria-expanded", "true");
    new RevolutionAnimation(DropdownContent, "true").slideDown();
  }

  closeAllDropdowns(namespace) {
    namespace.querySelectorAll(".Dropdown").forEach((dropdown) => {
      if (
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });
  }

  closeDropdown(elem, ignore) {
    if (this.lock && !ignore) return;
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");
    const transitionEndHandler = (event) => {
      if (event.propertyName === "height") {
        if (DropdownContent.getAttribute("aria-hidden") == "false") {
          DropdownContent.setAttribute("aria-hidden", "true");
        }

        this.lock = false;

        DropdownContent.removeEventListener(
          "transitionend",
          transitionEndHandler
        );
      }
    };

    DropdownContent.addEventListener("transitionend", transitionEndHandler);

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);
      }
    }
  }
}

const allDropdowns = new Dropdown();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    this.initialConfig = JSON.parse(
      element.getAttribute("data-swiper-settings")
    );

    if (additionalSwiper) {
      this.initialConfigThumbs = JSON.parse(
        additionalSwiper.getAttribute("data-swiper-thumb-settings")
      );
    }
    this.options = options;

    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {
      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.onEscBinder = this.onEsc.bind(this);
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );
    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    responsive.addResizeListener(this, this.calculateMaxHeightListener);
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.toggleDrawer();
    }
  }

  maxHeight() {
    if (this.element.id == 'Drawer' || this.element.id == 'collection__filter-drawer') return;
    const viewportHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--viewport-height"), 10);
    this.element.style.height = `${viewportHeight}px`;

    if (["cart", "sidebarFavorites"].includes(this.element.getAttribute("id"))) {
      const footer = this.element.querySelector(".CartDrawer--Footer");
      const headerEl = this.element.querySelector(".CartHeader");
      const itemWrapper = this.element.querySelector(".CartItems--Wrapper");

      const footerHeight = footer ? footer.offsetHeight : 0;
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;

      if (itemWrapper) {
        itemWrapper.style.height = `${viewportHeight - footerHeight - headerHeight}px`;
      }
    } else {

      const content = this.element.querySelector(".Drawer--Content");
      const header = this.element.querySelector(".Drawer--Header")?.offsetHeight || 0;
      const footer = this.element.querySelector(".Drawer--Footer")?.offsetHeight || 0;

      if (content) {
        if (this.element.id === "collection__filter-drawer") {
          const contentHeight = window.innerHeight;
          content.style.height = contentHeight + "px";
        } else {
          const contentHeight = window.innerHeight - header - footer;
          content.style.height = contentHeight + "px";
        }
        const loader = this.element.querySelector(".spinningLoader");
        if (loader && this.element.id === "favorites-drawer") {
          loader.style.height = contentHeight + "px";
          loader.style.top = header + "px";
        }
      }
    }
  }

  toggleDrawer() {
    event.preventDefault();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );

    this.element.dispatchEvent(
      new CustomEvent("close:other", { bubbles: true })
    );

    if (this.element.getAttribute("id") == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );
    }
    if (this.isOpen) {
      return;
    }

    dynamicVars.syncHeight();

    this.delegateElement.on("keydown", this.onEscBinder);

    this.maxHeight();
    if (this.element.getAttribute("id") == "Drawer") {

      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );
    }

    // Set to block before starting animation
    this.element.style.display = "block";
    this.element.offsetHeight;

    requestAnimationFrame(() => {
      this.element.setAttribute("aria-expanded", "true");
    });


    if (this.element.getAttribute("id") != "Drawer" || this.element.getAttribute("id") == "collection__filter-drawer") this.pageOverlayElement.classList.add("is-visible");
    this.pageOverlayElement.addEventListener("click", this._closeListener);



    var focus = this.element.querySelector("[data-scrollable]");
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");

    this.isOpen = true;

    this.onOpen();

    // Listen for transition end to update display when animation is done
    this.element.addEventListener("transitionend", this.onTransitionEnd.bind(this));

    return false;
  }


  closeDrawer(event) {
    if (!this.isOpen) {
      return;
    }

    if (this.element.id === 'Drawer' && document.querySelector('#modal-country[aria-hidden="false"]')) {
      return;
    }

    if (event) {
      event.preventDefault();
    }

    this.delegateElement.off("keydown", this.onEscBinder);

    if (this.element.getAttribute("id") == "cart") {
      var options = JSON.parse(this.element.getAttribute("data-settings"));
      if (options["showRecommendations"]) {
        this.element
          .querySelector(".CartDrawer--Expendable")
          .setAttribute("aria-expanded", false);
        setTimeout(() => {
          this.element.querySelector(".CustomCart__Recommendations").innerHTML =
            "";
        }, 800);
      }
    }

    this.element.setAttribute("aria-expanded", "false");

    document.body.classList.remove("scrollLock");
    // Listen for transition end to update display after closing animation
    this.element.addEventListener("transitionend", this.onTransitionEnd.bind(this));

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener("click", this._closeListener);

    removeTrapFocus(this.element);

    this.isOpen = false;
    this.onClose();
  }

  onTransitionEnd(event) {
    if (event.propertyName === "opacity") {
      trapFocus(this.element);

      if (this.element.getAttribute("aria-expanded") === "false") {
        this.element.style.display = "none";
        if (!document.body.classList.contains("scrollLock")) {
          bodyScrollLock.clearAllBodyScrollLocks();
        }
      } else {
        this.element.style.display = "block";
      }
    }
  }
}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate = node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);

        return false;
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }



  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFadeIn(toReveal) { /* Added fade in animation */

    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }

      setTimeout(() => {
        var elementMove = [
          // keyframes
          { opacity: "0" },
          { opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: 1000,
          easing: "cubic-bezier(.16,1.08,.38,.98)",
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {

    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {

          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          elementScaleOut: 'elementScaleOut',
          elementFadeIn: 'elementFadeIn'
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.15 }
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.delegateElement = new Delegate(this.element);
    if (this.element.getAttribute("data-settings")) {
      this.options = JSON.parse(this.element.getAttribute("data-settings"));
    } else {
      this.delegateElement.on("click", (e) => e.preventDefault());
      this.productModule = this.element.closest('product-component');
    }

    this.delegateElement.on("click", "button", this.onButtonClick.bind(this));
    this.delegateElement.on("input", "input", this.onInput.bind(this));
  }

  onInput() {
    if (this.options) {
      this.input.dispatchEvent(this.changeEvent);
      this.toggleAddButton();
    } else {
      this.productModule.updateAdditionalProductQuantity(this.input.dataset.variantId, parseInt(this.input.value));
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (this.options) {
      if (previousValue !== this.input.value)
        this.input.dispatchEvent(this.changeEvent);
      this.toggleAddButton();
    } else {
      this.productModule.updateAdditionalProductQuantity(this.input.dataset.variantId, parseInt(this.input.value));
    }
  }


  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelectorAll(".product-module__atc-button--main"),
      addButtonInner = document.querySelectorAll(".product-module__atc-button--main .ButtonText"),
      quantityEl = document.querySelector(".product-module__buy-buttons .product-module__quantity-input"),
      altButtons = document.querySelectorAll(".product-module__alt-atc-button");

    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (selectedVariant.available == false) {
      addButton.forEach(button => button.setAttribute("disabled", "disabled"));
      addButtonInner.forEach((btn) => {
        btn.innerHTML = window.variantStrings.soldOut;
      });
      altButtons.forEach(button => button.setAttribute("disabled", ""));
    } else {
      let price = this.options['price'];
      if (selectedVariant) {
        price = selectedVariant.price;
      }
      altButtons.forEach(button => button.removeAttribute("disabled"));
      addButton.forEach(button => button.removeAttribute("disabled"));
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='product-module__atc-price u-pb1'> - " +
          Shopify.formatMoney(
            price * quantity,
            window.theme.moneyFormat
          );
        +"</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner.forEach((btn) => {
        btn.innerHTML = window.variantStrings.addToCart + priceElement;
      });
    }
  }

}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector('.component-countDownWrapper');

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}', '<span class="u-pb6 component-countDown">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;


    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".component-countDown");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date') {
      countDate = new Date(this.options.countdownDate);
    }



    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;


    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);


    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes) && this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference - 1;
    } else if (this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }


    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);

class cartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.cartContent = this.element.querySelector('.cart-drawer__content');
    this.drawer = new Drawer(this.element, {
      onClose: () => {
        this.isOpen = false;
        this.recommendationsOpen = false;
        this.alreadyEntered = false;
        if (this.scrollListener) this.cartContent.removeEventListener('scroll', this.scrollListener);
      },
      onOpen: () => {
        if (responsive.matchesBreakpoint('pocket')) {
          this.scrollListener = this.onScroll.bind(this);
          this.cartContent.addEventListener('scroll', this.scrollListener);
          this.onScroll();
        }
      }
    });
    this.cartSummary = this.element.querySelector('.cart-drawer__summary');
    this.loader = this.element.querySelector(".itemLoader");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.cartIds = false;
    this.isOpen = false;
    this.recommendationsOpen = false;
    this.recommendationLoading = false;
    this.alreadyEntered = false;
    new AddToCart(this.element);
    this.bindEvents();
  }

  onScroll() {
    const cartSummary = this.element.querySelector('.cart-drawer__summary');
    if (!cartSummary) return;
    if (cartSummary.getBoundingClientRect().bottom == window.innerHeight) {
      cartSummary.classList.add('cart-drawer__summary--bg');
    } else {
      cartSummary.classList.remove('cart-drawer__summary--bg');
    }
  }

  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);

      if (this.options["showRecommendations"]) {
        window.addEventListener("load", () => this.loadRecommendations(true));
      }

      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "click",
        '[data-action="remove-all"]',
        this.removeBundle.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "quantity:changed",
        ".cart-item__quantity",
        this.updateItemQuantity.bind(this)
      );

      window.theme.listener = "true";
    }
  }

  onClose() {
    if (this.aboutToOpenRecommendaions) {
      clearTimeout(this.aboutToOpenRecommendaions);
    }
  }

  async updateItemQuantity(event, target) {
    if (event) {
      event.preventDefault();
    }

    let cartItem = target.closest(".cart-item");
    const itemLoader = cartItem.querySelector(".itemLoader");
    itemLoader.classList.add("is-visible");

    let quantity;
    if (target.tagName === "INPUT") {
      quantity = Math.max(parseInt(target.value, 10) || 0, 0);
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"), 10);
    }


    const bundleId = cartItem.dataset.bundleId;

    const payload = {
      id: target.getAttribute("data-line-id"),
      quantity: quantity,
    };

    if (quantity === 0) {
      const id = cartItem.dataset.id;
      if (this.cartIds) {
        this.cartIds = this.cartIds.filter((item) => item !== id);
      }

      let nextItem = cartItem.nextElementSibling;
      let skip = false;
      if (cartItem.hasAttribute('data-index')) {
        nextItem = this.getNextItem(cartItem);
        if (!nextItem) {
          const bundle = cartItem.closest('.bundle');
          nextItem = bundle.nextElementSibling;
          skip = true;
          if (cartItem.parentElement.children.length == 1) {
            this.animateElement(bundle, nextItem);
          } else {
            nextItem = this.getPreviousItem(cartItem);
            this.animateElement(cartItem, nextItem, true);
          }
        }
      }

      if (!skip) {
        this.animateElement(cartItem, nextItem);
      }
    }

    try {
      const response = await fetch(
        `${window.routes.localeRootUrl}/cart/change.js`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false, null, null, null, bundleId);
      }
      if (quantity == 0 && data.item_count > 0) {
        if (this.options.showRecommendations) {
          this.options["productId"] = data.items[0].product_id;
          this.renderCart(false, false, false, null, true, bundleId);
          return;
        }
      }
      if (data.item_count > 0 && quantity > 0) {
        this.renderCart(target.getAttribute("data-id"), true, null, null, null, bundleId);
      }
    } catch (error) {
      console.error("Failed to update item quantity:", error);
    }
  }

  async removeBundle(e, target) {
    e.preventDefault();
    const bundle = this.element.querySelector(`#bundle--${target.dataset.id}`);
    if (!bundle) {
      console.error("Bundle not found:", target.dataset.id);
      return;
    }

    try {
      // Collect all cart items inside the bundle
      const itemsToUpdate = [...bundle.querySelectorAll('.cart-item')].map(item => ({
        id: item.querySelector("[data-line-id]")?.dataset.lineId,
        quantity: 0
      }));

      if (itemsToUpdate.length === 0) {
        return;
      }

      // Make a single fetch request to update all items at once
      const response = await fetch(`${window.routes.localeRootUrl}/cart/update.js`, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ updates: Object.fromEntries(itemsToUpdate.map(item => [item.id, item.quantity])) })
      });

      if (!response.ok) {
        throw new Error("Failed to remove bundle from cart.");
      }

      let nextElement = bundle.nextElementSibling;
      if (nextElement) {
        this.animateElement(bundle, nextElement);
      } else {
        this.animateElement(bundle, bundle.previousElementSibling, true);
      }

      const data = await response.json();

      if (data.item_count == 0) {
        this.loader.classList.add("is-visible");
        this.renderCart(false, false);
      } else {
        this.renderCart(false, false, false, null, true, null);
      }
    } catch (error) {
      console.error("Error removing bundle:", error);
    }
  }


  animateElement(element, nextElement, reverse) {
    let animClass = "repo--top";
    if (reverse) {
      animClass = "repo--bottom";
    }
    element.classList.add("removing");
    const height = element.offsetHeight;
    document.documentElement.style.setProperty(
      "--repositioning_value",
      `${height}px`
    );

    setTimeout(() => {
      requestAnimationFrame(() => {
        element.remove();
        if (!nextElement) {
          return;
        }
        nextElement.classList.add(animClass);
        setTimeout(() => {
          nextElement.classList.remove(animClass);
        }, 350);
      });
    }, 350);
  }

  getPreviousItem(item) {
    const container = item.parentElement;

    // Get all children excluding the current item
    let remainingItems = [...container.children].filter(el => el !== item);

    // Find the child with the largest index
    let nextLargestItem = remainingItems.reduce((maxItem, el) => {
      let index = parseInt(el.dataset.index, 10);
      return (!maxItem || index > parseInt(maxItem.dataset.index, 10)) ? el : maxItem;
    }, null);

    return nextLargestItem;
  }

  getNextItem(item) {
    const container = item.parentElement;
    const currentIndex = parseInt(item.dataset.index, 10);

    let remainingIndices = [...container.children]
      .map(el => parseInt(el.getAttribute("data-index"), 10))
      .filter(index => index > currentIndex)
      .sort((a, b) => a - b);

    let nextItem = remainingIndices.length > 0
      ? [...container.children].find(el => parseInt(el.dataset.index, 10) === remainingIndices[0])
      : null;

    return nextItem;
  }

  onProductAdded() {
    let details = false;
    if (event.detail) {
      details = event.detail;
    }

    if (window.theme.cartCount == 0 && this.isOpen == true) {
      this.loader.classList.add("is-visible");
    }

    this.renderCart(false, false, true, details).then(() => {
      if (this.element.hasAttribute("data-open-drawer")) {
        if (this.isOpen == false) {
          this.isOpen = true;
          this.alreadyEntered = true;
          this.drawer.openDrawer();
        }
      }
    });
  }

  renderCart(
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount,
    bundleId
  ) {
    this.pageLoader.style.width = 100 + "%";
    var _this = this;
    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(
          html,
          lineNumber,
          quantityChange,
          productAdd,
          productAddEvent,
          updateCount,
          bundleId
        );
        if (_this.options.showRecommendations) {
          _this.loadRecommendations();
        }
      });
    });
  }

  replaceContent(
    html,
    lineNumber,
    quantityChange,
    productAdd,
    productAddEvent,
    updateCount,
    bundleId
  ) {
    if (!updateCount) {
      // Prepare the page loader animation
      this.pageLoader.style.left = "unset";
      this.pageLoader.style.right = "0px";
      this.pageLoader.style.width = "0%";

      setTimeout(() => {
        this.pageLoader.style.left = "0px";
        this.pageLoader.style.right = "unset";
      }, 550);
    }

    // Create a temporary element to parse the new HTML content
    const tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    // Extract options and update cart count
    const newOptions = JSON.parse(
      tempElement.querySelector("#cart-drawer").getAttribute("data-settings")
    );
    const oldOptions = this.options;
    this.options = newOptions;

    if (!updateCount) {
      if (tempElement.querySelector("[data-ids]") != undefined) {
        this.cartIds = tempElement
          .querySelector("[data-ids]")
          .dataset.ids.split(",")
          .filter((item) => item !== "");
      }
    }

    let itemCount = parseInt(newOptions.itemCount) === 0 ? '' : newOptions.itemCount;
    window.theme.cartCount = parseInt(itemCount);

    if (itemCount == 0) {
      document.querySelector('.cart-icon').setAttribute('aria-hidden', true);
    } else {
      document.querySelector('.cart-icon').setAttribute('aria-hidden', false);
    }

    const cartCountElements = document.querySelectorAll(".cart__count");
    cartCountElements.forEach(el => el.innerHTML = `(${itemCount})`);

    let oldOptionsInfoCount = parseInt(oldOptions.itemCount) === 0 ? '' : oldOptions.itemCount;

    if (bundleId) {
      this.updateBundlePrice(tempElement, bundleId);
    }

    if (updateCount) { this.updateCartFooter(tempElement); return; }
    if (lineNumber) {
      this.updateCartItem(lineNumber, tempElement);
    } else if (productAdd && oldOptionsInfoCount > 1) {
      this.addContent(tempElement, productAddEvent);
    } else {
      this.replaceCartContent(tempElement);
    }
    this.updateCartFooter(tempElement);


    // Additional actions after a brief delay
    setTimeout(() => {
      if (
        this.options.showRecommendations &&
        !quantityChange &&
        this.isOpen == true
      ) {
        this.loadRecommendations();
      }
      const focusElement = this.element.querySelector("[data-scrollable]");
      if (this.element.hasAttribute("data-open-drawer")) {
        bodyScrollLock.disableBodyScroll(focusElement, bodyScrollLockOptions);
        document.body.classList.add("scrollLock");
      }
      this.drawer.maxHeight();
    }, 200);
  }

  updateBundlePrice(tempElement, bundleId) {
    const bundlePrice = this.element.querySelector(`#bundle--${bundleId}`).lastElementChild;
    const newBundlePrice = tempElement.querySelector(`#bundle--${bundleId}`).lastElementChild;

    if (bundlePrice.parentElement) {
      bundlePrice.parentElement.replaceChild(newBundlePrice, bundlePrice);
    }
  }

  updateCartItem(lineNumber, tempElement) {
    const cartItemParent = this.element.querySelector(`#${lineNumber}`);
    const newCartItemInfo = tempElement.querySelector(
      `#${lineNumber} .cart-item__details`
    );

    if (!cartItemParent) {
      this.element.querySelector(".itemLoader").classList.remove("is-visible");
    } else {
      cartItemParent
        .querySelector(".itemLoader")
        .classList.remove("is-visible");
    }

    if (newCartItemInfo) {
      cartItemParent.replaceChild(
        newCartItemInfo,
        cartItemParent.querySelector(".cart-item__details")
      );
    }
  }

  addContent(tempElement, productAddEvent) {
    if (this.isOpen) {
      this.element.querySelector(".cart-drawer__content").scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }

    const cartWrapper = this.element.querySelector(".cart-drawer__items");

    let itemsToAdd = [];
    const variants = Array.isArray(productAddEvent.variant) ? productAddEvent.variant : [productAddEvent.variant];

    const isBundle = productAddEvent.bundle_id;

    if (isBundle) {
      const itemToAdd = tempElement.querySelector(`#bundle--${productAddEvent.bundle_id}`);
      const height = this.calculateDetachedElement(itemToAdd);
      document.documentElement.style.setProperty("--repositioning_value", `${height}px`);
      itemsToAdd.push({ itemToAdd, height });
    } else {
      itemsToAdd = variants.map(variant => {
        const itemToAdd = tempElement.querySelector(`#cart-item__${variant}`);
        if (cartWrapper.querySelector(`#cart-item__${variant}`)) {
          this.updateCartItem(`cart-item__${variant}`, tempElement);
          return null;
        }

        const height = this.calculateDetachedElement(itemToAdd);
        return { itemToAdd, height };
      }).filter(item => item !== null);

      if (!itemsToAdd.length) return;
    }

    const totalHeight = itemsToAdd.reduce((sum, item) => sum + item.height, 0);
    document.documentElement.style.setProperty("--repositioning_value", `${totalHeight}px`);

    this.loader.classList.remove("is-visible");

    setTimeout(() => {
      itemsToAdd.forEach(({ itemToAdd }) => {
        cartWrapper.prepend(itemToAdd);
        itemToAdd.classList.add("repo--adding");
      });

      if (isBundle) {
        this.element.querySelectorAll(".bundle-count").forEach((el, index) => {
          el.innerHTML = index + 1; // Starts from 1 instead of 0
        });
      }

      setTimeout(() => {
        itemsToAdd.forEach(({ itemToAdd }) => {
          itemToAdd.classList.remove("repo--adding");
        });
      }, 350);
    }, 350);
  }


  calculateDetachedElement(element) {
    // 1. Create a detached container
    const detachedContainer = document.createElement("div");
    detachedContainer.style.position = "absolute";
    detachedContainer.style.visibility = "hidden";
    detachedContainer.style.height = "auto";
    detachedContainer.style.width = "auto";
    detachedContainer.style.top = "-9999px"; // Off-screen positioning

    // 2. Append the new item to the detached container
    detachedContainer.appendChild(element);

    // 3. Append the detached container to the body (but off-screen)
    this.element.appendChild(detachedContainer);

    // 4. Get the offset height of the new item
    const newItemHeight = element.offsetHeight + 16;

    // 5. Remove the detached container from the DOM
    this.element.removeChild(detachedContainer);

    // Now you have the height of the new item without it ever being visible
    return newItemHeight;
  }

  updateCartFooter(tempElement) {
    const cartFooter = this.element.querySelector(".cart-drawer__summary");
    if (tempElement.querySelector(".cart-drawer__summary") && !cartFooter) {
      this.element.querySelector('.cart-drawer__wrapper').appendChild(tempElement.querySelector(".cart-drawer__summary"));
    } else if (tempElement.querySelector(".cart-drawer__summary") && cartFooter) {
      this.element.querySelector('.cart-drawer__content-wrapper').replaceChild(tempElement.querySelector(".cart-drawer__summary"), cartFooter);
    }
    const footerParent = this.element.querySelector(".cart-drawer__content-wrapper");
    const newFooterTotals = tempElement.querySelector(
      ".cart-drawer__summary"
    );
    if (responsive.matchesBreakpoint('pocket')) this.onScroll();
    if (!footerParent || !newFooterTotals) return;
    footerParent.replaceChild(
      newFooterTotals,
      footerParent.querySelector(".cart-drawer__summary")
    );

    this.drawer.maxHeight();
  }

  replaceCartContent(tempElement) {
    const cartWrapperParent = this.element.querySelector(
      ".cart-drawer__wrapper"
    ).parentNode;
    const currentScrollPosition = this.element.querySelector(
      ".cart-drawer__content"
    ).scrollTop;

    cartWrapperParent.replaceChild(
      tempElement.querySelector(".cart-drawer__wrapper"),
      this.element.querySelector(".cart-drawer__wrapper")
    );

    setTimeout(() => {
      this.loader.classList.remove("is-visible");
    }, 200);
    this.element.querySelector(".cart-drawer__content").scrollTop =
      currentScrollPosition;

  }

  loadRecommendations(firstLoad) {
    let recommendationsContainer = this.element.querySelector(
      ".cart-drawer__recommendations"
    );

    if (this.recommendationLoading == true || (this.isOpen == false && !firstLoad) || !recommendationsContainer) return;
    this.recommendationLoading = true;


    const productId = this.options["productId"];
    const baseUrl = window.routes.localeRootUrl;
    let url;

    // Determine the URL based on whether a product ID is present
    if (!productId) {
      url = "?section_id=helper-recommendations";
    } else {
      let limit = this.element.getAttribute("product-limit");
      url = `${baseUrl}/recommendations/products?section_id=helper-recommendations&product_id=${productId}&l${limit}`;

    }


    recommendationsContainer.classList.remove("transition--done");
    if (this.recommendationsOpen == true) {
      recommendationsContainer.classList.add("transition");
    }

    return fetch(url)
      .then((response) => response.text())
      .then((content) => {
        this.recommendationLoading = false;
        const container = document.createElement("div");
        container.innerHTML = content;

        let recommendationsHTML = container.querySelector(
          ".cart-drawer__upsell"
        )?.innerHTML;

        const newFirstItem = container.querySelector(".cart-drawer__rec-item")?.dataset.id;
        const existingFirstItem = this.element.querySelector(".cart-drawer__rec-item")?.dataset.id;

        if (newFirstItem == existingFirstItem) { return; }

        if (recommendationsHTML) {
          recommendationsContainer.innerHTML = recommendationsHTML;
          this.initializeSwiper();
          new AddToCart(this.element);
          recommendationsContainer.setAttribute(
            "data-animation",
            "elementFadeIn"
          );
          if (window.theme.enableAnimations) {
            new RevolutionAnimation(recommendationsContainer);
          }

          document.dispatchEvent(new CustomEvent('update-favorites'));

        }
      })
      .catch((error) => {
        console.error("Failed to load recommendations:", error);
      });


  }

  handleTransitionRec(target, container) {
    if (event.propertyName !== "transform") return;
    target.setAttribute("aria-hidden", "true");
    target.style.display = "none";
    container.classList.remove("transition");
    this.recommendationsOpen = false;
    this.el.removeEventListener("transitionend", this.transitionRecEnd);
  }

  initializeSwiper() {
    new Swiper(".helper-recomm-swiper", {
      slidesPerView: 1.36,
      spaceBetween: 8,
      allowTouchMove: true,
      navigation: {
        nextEl: ".swiperButtonNext-recommendations",
        prevEl: ".swiperButtonPrevious-recommendations",
      },
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        1025: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
        1440: {
          slidesPerView: 5,
          spaceBetween: 16,
        },
      },
    });
  }

}
customElements.define("cart-drawer", cartDrawer);

class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();

    new AddToCart(this.element);
  }

  bindEvents() {
    this.isPageLoaded =
      document.readyState === "complete" ||
      document.readyState === "loaded" ||
      document.readyState === "interactive";
    if (!this.isPageLoaded) {
      window.addEventListener("load", this.onPageLoaded.bind(this));
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (!this.carousel) this.carousel = new RevolutionSwiper(this.carouselElement);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);

class CollectionShowcase extends HTMLElement {
  constructor() {
    super();

    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.responsive = new Responsive();
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.outerWrapper = this.element.querySelector('.collection-showcase__image-outer-wrapper');

    this.prepareCollection();
    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-collection"]',
      (event) => {
        if (this.breakpoint === 'pocket' || this.breakpoint === 'phone') {
          this.toggleCollection(event);
        }
      }
    );

    this.delegateElement.on(
      "mouseover",
      '[data-action="toggle-collection"]',
      (event) => {
        if (this.breakpoint === 'desktop') {
          this.toggleCollection(event);
        }
      }
    );
  }

  prepareCollection() {
    const firstCollectionImage = this.element.querySelector(".collection-showcase__image-container");
    const firstCollectionContentBlock = this.element.querySelector(".collection-showcase__content-block");
    const firstCollectionContentBlockDesktop = this.element.querySelector(".collection-showcase__content-block-desktop");
    const firstCollectionTab = this.element.querySelector(".collection-showcase__tab");
    if (responsive.matchesBreakpoint('pocket')) {
      firstCollectionImage.style.display = "flex";
      if (firstCollectionContentBlockDesktop) firstCollectionContentBlockDesktop.style.display = "flex";
    } else {
      firstCollectionImage.style.opacity = "1";
      if (firstCollectionContentBlockDesktop) firstCollectionContentBlockDesktop.style.opacity = "1";
    }
    this.outerWrapper.style.aspectRatio = firstCollectionImage.dataset.ratio;
    if (firstCollectionContentBlock) firstCollectionContentBlock.style.display = "flex";

    firstCollectionTab.classList.add("active");
  }

  toggleCollection(event) {
    const tab = event.target.closest(".collection-showcase__tab");
    if (!tab) return;

    const targetId = tab.getAttribute("id");

    const collectionImages = this.element.querySelectorAll(".collection-showcase__image-container");
    const collectionContentBlocks = this.element.querySelectorAll(".collection-showcase__content-block");
    const collectionContentBlocksDesktop = this.element.querySelectorAll(".collection-showcase__content-block-desktop");
    const collectionTabs = this.element.querySelectorAll(".collection-showcase__tab");

    const toggleVisibility = (elements) => {
      elements.forEach(el => {
        if (responsive.matchesBreakpoint('pocket')) {
          el.style.display = el.getAttribute("id") === targetId ? "flex" : "none";
        } else {
          el.style.opacity = el.getAttribute("id") === targetId ? "1" : "0";
        }
        el.style.pointerEvents = el.getAttribute("id") === targetId ? "initial" : "none";
        if (el.getAttribute("id") === targetId) this.outerWrapper.style.aspectRatio = el.dataset.ratio;
      });
    };

    toggleVisibility(collectionImages);

    if (this.breakpoint === "pocket" || this.breakpoint === "phone") {
      toggleVisibility(collectionContentBlocks);
    } else if (this.breakpoint === "desktop") {
      toggleVisibility(collectionContentBlocksDesktop);
    }

    collectionTabs.forEach(t => t.classList.toggle("active", t === tab));
  }

}

customElements.define("collection-showcase", CollectionShowcase);


class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);


  }
}
customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.delegateElement = new Delegate(this.element);
  }
}
customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector('[data-scrollable]');
    this.headerTransparent = false;
    this.lastScrollTop = 0;
    this.responsive = new Responsive();
    this.breakpoint = this.responsive.getCurrentBreakpoint();
    this.isHeroBanner = this.isHeroBanner();
    this.isHomePage = this.options["isHomePage"];

    if (this.options.sticky) {
      this.toggleSticky();
    }
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );

    if (this.isHeroBanner && this.isHomePage) this.hideTopbarLogo();
    this.setTopBarBackground();
    this.updateVisibleHeight();
    this.bindEvents();

  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);
    if (this.element.classList.contains('hide-header')) {
      visibleHeight = 0;
    }
    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty('--header-dynamic-height', `${visibleHeight}px`);
  }


  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");
    this.element.parentElement.classList.remove("Header--Transparent");
  }

  bindEvents() {

    this.animateLogoListener = this.animateLogo.bind(this);

    scrollListener.addScrollListener(this, this.animateLogoListener);

    scrollListener.addScrollListener(this, this.updateVisibleHeight.bind(this));
    responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${document.querySelector('#header').offsetHeight}px`
    );
  }

  animateLogo() {
    const currentScrollTop = window.scrollY;
    const isMobile = this.breakpoint === 'pocket' || this.breakpoint === 'phone';

    const productBanner = document.querySelector(".product-module__banner");
    const heroBannerDesktop = document.querySelector(".banner__imageContainer.not_mobile");
    const heroBannerMobile = document.querySelector(".banner__imageContainer.not_desktop");
    const heroBannerVideo = document.querySelector(".hero-banner__video-container");
    const articleHeader = document.querySelector(".main-article__banner");
    const articleHeaderMobile = document.querySelector(".main-article__banner-mobile");
    const articleHeaderVideo = document.querySelector(".main-article__banner-video");

    const logoTopbar = this.element.querySelector(".header--LogoWrapper");

    let heroBannerHeight = this.getHeroBannerHeight(isMobile, heroBannerDesktop, heroBannerMobile, heroBannerVideo, articleHeader, articleHeaderMobile, articleHeaderVideo, productBanner);
    if (this.options.transparent) this.handleTransparentTopbar(currentScrollTop, heroBannerHeight);

    this.handleLogos(currentScrollTop, isMobile, logoTopbar, heroBannerMobile, heroBannerDesktop, heroBannerVideo);

    this.lastScrollTop = Math.max(0, currentScrollTop);
  }

  setTopBarBackground() {
    this.element.classList.add('remove-transition');
    if (this.isHeroBanner && this.options.transparent) this.element.classList.add("Header--Transparent");
    if (!this.isHeroBanner) this.element.classList.remove("Header--Transparent");
    setTimeout(() => {
      this.element.classList.remove('remove-transition');
    }, 500);
  }

  getHeroBannerHeight(isMobile, heroBannerDesktop, heroBannerMobile, heroBannerVideo, articleHeader, articleHeaderMobile, articleHeaderVideo, productBanner) {
    if (isMobile && heroBannerMobile) return heroBannerMobile.offsetHeight;
    if (!isMobile && heroBannerDesktop) return heroBannerDesktop.offsetHeight;
    if (heroBannerVideo) return heroBannerVideo.offsetHeight;
    if (productBanner) return productBanner.offsetHeight;
    if (!isMobile && articleHeader) return articleHeader.offsetHeight;
    if (isMobile && articleHeaderMobile) return articleHeaderMobile.offsetHeight;
    if (articleHeaderVideo) return articleHeaderVideo.offsetHeight;

    return 0;
  }

  hideTopbarLogo() {
    const logoTopbar = this.element.querySelector(".header--LogoWrapper");
    logoTopbar.classList.add("hide-logo");
  }

  isHeroBanner() {
    const productBanner = document.querySelector(".product-module__banner");
    const heroBannerDesktop = document.querySelector(".banner__imageContainer.not_mobile");
    const heroBannerMobile = document.querySelector(".banner__imageContainer.not_desktop");
    const heroBannerVideo = document.querySelector(".hero-banner__video-container");
    const articleHeader = document.querySelector(".main-article__banner");
    const articleHeaderMobile = document.querySelector(".main-article__banner-mobile");
    const articleHeaderVideo = document.querySelector(".main-article__banner-video");
    if (heroBannerDesktop || heroBannerMobile || heroBannerVideo || articleHeader || articleHeaderMobile || articleHeaderVideo || productBanner) return true;
    return false;
  }

  handleTransparentTopbar(currentScrollTop, heroBannerHeight) {
    const bannerStart = -1;
    const bannerEnd = heroBannerHeight;

    if (currentScrollTop > bannerStart && currentScrollTop < bannerEnd) {
      this.element.classList.add("Header--Transparent");
    } else {
      this.element.classList.remove("Header--Transparent");
      this.element.classList.add("hide-header");
    }
  }

  handleLogos(currentScrollTop, isMobile, logoTopbar, heroBannerMobile, heroBannerDesktop, heroBannerVideo) {
    const logoBannerMobile = heroBannerMobile?.querySelector(".hero-banner__logo__wrapper");
    const logoBannerDesktop = heroBannerDesktop?.querySelector(".hero-banner__logo__wrapper");
    const logoBannerVideo = heroBannerVideo?.querySelector(".hero-banner__logo__wrapper");

    let threshold = 10;
    if (currentScrollTop > this.lastScrollTop) {
      if (currentScrollTop > threshold) {
        if (this.isHeroBanner && this.isHomePage) logoTopbar.classList.remove("hide-logo");

        if (isMobile && logoBannerMobile) logoBannerMobile.classList.add("hide-logo");
        if (!isMobile && logoBannerDesktop) logoBannerDesktop.classList.add("hide-logo");
        if (logoBannerVideo) logoBannerVideo.classList.add("hide-logo");
      }
    } else {
      this.element.classList.remove("hide-header");
      if (currentScrollTop <= threshold) {
        if (this.isHeroBanner && this.isHomePage) logoTopbar.classList.add("hide-logo");

        if (isMobile && logoBannerMobile) logoBannerMobile.classList.remove("hide-logo");
        if (!isMobile && logoBannerDesktop) logoBannerDesktop.classList.remove("hide-logo");
        if (logoBannerVideo) logoBannerVideo.classList.remove("hide-logo");
      }
    }
  }


}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.SidebarMenu = new Drawer(this.element);
    this.searchInput = this.element.querySelector(".mobile-menu__search");
    this.clearBtn = this.element.querySelector(".mobile-menu__clear-btn");
    this.searchPlaceholderButton = this.element.querySelector(".mobile-menu__search-btn");

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="search"]',
      this.onSearch.bind(this)
    );
  }

  onSearch(event) {
    event.preventDefault();
    let searchQuery = this.searchInput.value.trim();

    if (searchQuery) {
      window.location.href = `/search?q=${searchQuery}`;
    }
    this.searchInput.focus();
  }

}
customElements.define("main-menu-popup", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {

      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    if (this.options["using_fade"] == "fade") {
      if (
        this.element.dataset.position == 0 ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-active") ||
        this.element
          .closest(".swiper-slide")
          .classList.contains("swiper-slide-duplicate-active")
      ) {
        this.checkLoaded();
        this.bindEvents();
      } else {
        this.bindEvents();
      }
    } else {
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const responsive = new Responsive();
    const isMobile = responsive.matchesBreakpoint('pocket');

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }

        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );

        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["video_ratio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }

    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: false,
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }

      _this.bindCustomControls();
    });

    if (this.options["controls"]) {
      let lastTouchTime = 0;

      if (host == "html5") {
        this.videoPlayer.on("touchstart", function (e) {
          lastTouchTime = new Date().getTime();

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      this.videoPlayer.on("click", function () {
        if (new Date().getTime() - lastTouchTime < 300) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  bindCustomControls() {
    this.stateElement = this.element.querySelector(
      "[data-action='toggle-state']"
    );

    this.soundElement = this.element.querySelector(
      "[data-action='toggle-sound']"
    );

    if (!this.stateElement || !this.soundElement) return;

    this.delegateElement.on("click", "[data-action='toggle-state']", () =>
      this.videoPlayer.paused()
        ? this.videoPlayer.play()
        : this.videoPlayer.pause()
    );
    this.delegateElement.on("click", "[data-action='toggle-sound']", () =>
      this.videoPlayer.muted()
        ? this.videoPlayer.muted(false)
        : this.videoPlayer.muted(true)
    );

    this.videoPlayer.on("play", () =>
      this.stateElement.setAttribute("aria-label", "playing")
    );
    this.videoPlayer.on("pause", () =>
      this.stateElement.setAttribute("aria-label", "paused")
    );
    this.videoPlayer.on("volumechange", () =>
      this.soundElement.setAttribute(
        "aria-label",
        this.videoPlayer.muted() ? "muted" : "unmuted"
      )
    );
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          this.videoPlayer.muted("true");

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100);
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.footer = document.querySelector("footer");
    this.footerVisibleClass = "footer--visible";
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      // this.dropdown = new Dropdown(this.element);
    }
    if (responsive.matchesBreakpoint("lap_and_up")) {
      this.initScrollEffect();
    }
  }

  connectedCallback() {
    document.documentElement.style.setProperty(
      "--footer-dynamic-height",
      this.footer.offsetHeight + "px"
    );
    window.addEventListener("load", () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.footer.offsetHeight + "px"
      );
    });
    responsive.addResizeListener(this, () => {
      document.documentElement.style.setProperty(
        "--footer-dynamic-height",
        this.footer.offsetHeight + "px"
      );
    });
  }
  initScrollEffect() {

    const handleScroll = () => {
      const footerRect = this.footer.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      const footerVisibleHeight = Math.min(footerRect.bottom, viewportHeight) - Math.max(footerRect.top, 0);
      const footerHeight = footerRect.height;
      const visibilityPercentage = Math.max(0, Math.min(footerVisibleHeight / footerHeight, 1));

      const translateY = (1 - visibilityPercentage) * -20;
      this.footer.style.transform = `translateY(${translateY}%)`;
    };

    window.addEventListener("scroll", handleScroll);


  }
}
customElements.define("footer-component", FooterComponent);


var contentCache = {};
let activeSlide = null;
let convertedArea = 0;
const SQM_TO_SQFT = 10.764;
const SQFT_TO_SQM = 1 / SQM_TO_SQFT;
class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.changeImageQuality();

    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector(".product-module__main-swiper");
    this.carouselElementThumbs = this.element.querySelector(".product-module__thumbnail-swiper");
    this.options = JSON.parse(this.carouselElement.getAttribute("data-section-settings"));

    this.updateLabels();

    if (this.element.querySelector('[data-init-swiper="true"]')) {
      this.carousel = new RevolutionSwiper(
        this.carouselElement,
        this.carouselElementThumbs
      );
    }

    if (this.element.querySelector('[data-enable-zoom="true"]')) {
      new RevolutionImageZoom(this.element, this.carouselElement);
    }

    this.element.querySelectorAll('.product-module__connected-items-swiper').forEach(swiperElement => {
      new RevolutionSwiper(swiperElement);
      if (activeSlide) swiperElement.swiper.slideTo(activeSlide, 0);
      swiperElement.swiper.on("slideChange", () => { activeSlide = swiperElement.swiper.activeIndex; });
      swiperElement.swiper.on("reachEnd", () => {
        setTimeout(() => {
          activeSlide = swiperElement.swiper.slides.length - 1;
        }, 200);
      });
      setTimeout(() => {
        swiperElement.classList.add("transition");
      }, 100);
    });

    let urlParams = new URLSearchParams(window.location.search);
    let areaValue = urlParams.get('area');

    this.bannerSwiper = this.element.querySelector('.product-module__banner-swiper');
    const areaSlide = this.bannerSwiper?.querySelector(`.swiper-slide[data-area="${areaValue}"]`);
    if (areaValue && this.bannerSwiper && areaSlide) {
      let settings = JSON.parse(this.bannerSwiper.getAttribute('data-swiper-settings'));
      settings.initialSlide = areaSlide.dataset.index;
      this.bannerSwiper.setAttribute('data-swiper-settings', JSON.stringify(settings));

      new RevolutionSwiper(this.bannerSwiper);
    } else if (this.bannerSwiper) {
      new RevolutionSwiper(this.bannerSwiper);
    }

    this.element.querySelectorAll('.product-module__toggle-drawer').forEach(button => new Drawer(this.element.querySelector(`#${button.dataset.toggleId}`)));
    this.element.querySelectorAll('.product-module__toggle-drawer').forEach(button => document.body.appendChild(this.element.querySelector(`#${button.dataset.toggleId}`)));
    this.activeUnit = this.element.querySelector('[data-active-unit]')?.dataset.activeUnit;
    this.purchaseOptions = this.element.querySelector('.product-module__purchase-options');
    this.areaOptions = this.element.querySelector('.product-module__area');
    this.buyButtons = this.element.querySelector('.product-module__buy-buttons');
    this.areaTemplates = this.element.querySelector('.area__templates');
    this.quantityInput = this.element.querySelector('.product-module__buy-buttons quantity-input');
    this.completePurchaseButton = this.element.querySelector('.product-module__complete-button');
    this.atcPriceSpan = this.element.querySelector('.product-module__atc-price');
    this.atcButton = this.element.querySelector('.product-module__atc-button--main');
    this.atcButtonInner = this.atcButton.querySelector('.ButtonText');
    this.altButtons = this.element.querySelectorAll('.product-module__alt-atc-button');
    this.notifyButtons = document.querySelectorAll(".product-module__notify-button");
    this.requiredVariants = [];

    if (this.element.querySelector('[data-active-unit]')) {
      this.span = this.element.querySelector(".hidden-span");
    }

    new AddToCart(this.element);

    this.stickyPopup = this.element.querySelector(".product-module__sticky-popup");

    if (this.options["variant_image_id"] && this.options["show_variant_image_on_load"]) {
      this.updateImage();
    }
    this.bindEvents();
    const area = new URL(window.location).searchParams.get('area');
    if (area) {
      const areaToClick = this.element.querySelector(`.area__option-input[value="${area}"]`);
      if (areaToClick) {
        const label = areaToClick.nextElementSibling;
        label.style.transition = 'none';
        areaToClick.click();
        requestAnimationFrame(() => {
          label.offsetHeight;
          label.style.transition = '';
        })
      }
    }
    const hash = window.location.hash.substring(1);
    if (hash) {
      this.toggleTemplate('first', this.element.querySelector(`[data-action="toggle-template"][aria-controls="${hash}"]`));
    } else {
      this.toggleTemplate('first', this.element.querySelector('[data-action="toggle-template"][aria-expanded="true"]'));
    }
  }

  bindEvents() {
    if (this.element.querySelector('[data-load="true"]')) {
      window.addEventListener("popstate", this.reloadPage.bind(this));
      window.addEventListener("DOMContentLoaded", this.reloadWithoutRefresh.bind(this));
      this.delegateElement.on("click", '[data-action="handle-reload"]', this.updateContentWithoutReload.bind(this));
    }

    this.delegateElement.on("click", '[data-action="toggle-template"]', this.toggleTemplate.bind(this));
    this.delegateElement.on("click", '[data-action="toggle-unit"]', this.toggleUnit.bind(this));

    if (this.element.querySelector('[data-init-swiper="true"]')) {
      this.delegateElement.on("variant:changed", this.updateImage.bind(this));
    }

    if (this.element.querySelector('[data-action="select-additional"]')) {
      this.delegateElement.on("change", '[data-action="select-additional"]', this.selectAdditional.bind(this));
    }

    if (this.element.querySelector('[data-active-unit]')) {
      this.delegateElement.on("input", '[name="calculator"]', this.followInputValue.bind(this));
      this.delegateElement.on("click", '[data-action="calculate"]', this.calculate.bind(this));
      this.delegateElement.on("click", '[data-action="remove-additional"]', this.removeAdditionalProduct.bind(this));
    }

    if (this.stickyPopup) {
      this.delegateElement.on("click", '[data-action="customize"]', this.scrollTo.bind(this));
      scrollListener.addScrollListener(this, this.showStickyAtc.bind(this));
      window.addEventListener("DOMContentLoaded", this.showStickyAtc.bind(this));
    }
  }

  scrollTo() {
    const sectionGroup = document.querySelector(".product-module__section-group");
    const headerHeight = document.querySelector("header-component").offsetHeight;

    if (sectionGroup) {
      const offsetTop = sectionGroup.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top: offsetTop, behavior: "smooth" });
    }
  }

  updateLabels() {
    document.querySelectorAll('.product-module__selector-label:not([aria-hidden="true"])').forEach((label, index, labels) => {
      const total = labels.length;
      let bullet = label.querySelector('.product-module__bullet');

      if (bullet) {
        bullet.textContent = `${index + 1}/${total}`;
      }
    });
  }

  updateImage(event) {
    if (event) {
      var imageID = event.detail.new_image;
    } else {
      var imageID = this.options["variant_image_id"];
    }

    var selector = "#product-module__image--" + imageID;
    var imageEl = this.element.querySelector(selector);

    if (imageEl) {
      this.carousel.selectCell(parseInt(imageEl.getAttribute("data-position")));
    }
  }

  removeAdditionalProduct(e, target) {
    e.preventDefault();
    const variantId = target.parentElement.dataset.variantId;
    const variantToRemove = this.requiredVariants.find(variant => variant.variant_id == variantId);

    if (!variantToRemove) return;

    if (variantToRemove.base_coat) {
      this.requiredVariants = this.requiredVariants.filter(variant => !variant.pigment);
    }

    this.requiredVariants = this.requiredVariants.filter(variant => variant.variant_id != variantId);

    this.renderUIElements();
  }


  updateAdditionalProductQuantity(variantId, newQuantity) {
    let isBaseCoat = false;

    this.requiredVariants = this.requiredVariants.map(variant => {
      if (variant.variant_id == variantId) {
        if (variant.base_coat) {
          isBaseCoat = true;
        }
        return { ...variant, quantity: newQuantity };
      }
      return variant;
    });

    if (isBaseCoat) {
      this.recalculatePigment(newQuantity);
    }

    this.renderUIElements();
  }

  convertAreaToMeters(area, fromUnit, toUnit) {
    if (fromUnit === toUnit) return area;
    return fromUnit === "m²" ? area * SQM_TO_SQFT : area * SQFT_TO_SQM;
  }
  getOptimizedVariantQuantities(area, variants, smallestVariantCoverage) {
    if (!Array.isArray(variants) || variants.length === 0 || !smallestVariantCoverage) {
      return {};
    }

    let selectedVariants = {}, remainingArea = area;

    let sortedVariants = variants
      .map(v => ({ ...v, numericSize: parseFloat(v.size.match(/[\d.]+/)[0]) || 0 }))
      .sort((a, b) => b.numericSize - a.numericSize);

    let smallestVariant = sortedVariants.reduce((smallest, v) =>
      (v.numericSize < smallest.numericSize ? v : smallest), sortedVariants[0]);

    if (!smallestVariant.numericSize) {
      console.error("Error: Could not determine smallest variant size.");
      return {};
    }

    sortedVariants.forEach(v => {
      v.coverage = (v.numericSize / smallestVariant.numericSize) * smallestVariantCoverage;
    });

    for (let v of sortedVariants) {
      let quantityNeeded = Math.floor(remainingArea / v.coverage);
      if (quantityNeeded > 0) {
        selectedVariants[v.variant_id] = {
          quantity: quantityNeeded,
          price: v.available ? v.price : 0  // ✅ Only set price if available
        };
        remainingArea -= quantityNeeded * v.coverage;
      }
    }

    if (remainingArea > 0) {
      let extraQuantity = Math.ceil(remainingArea / smallestVariant.coverage);
      let selected = selectedVariants[smallestVariant.variant_id];

      if (selected) {
        selected.quantity += extraQuantity;
      } else {
        selectedVariants[smallestVariant.variant_id] = {
          quantity: extraQuantity,
          price: smallestVariant.available ? smallestVariant.price : 0  // ✅ Only set price if available
        };
      }
    }

    return Object.entries(selectedVariants).sort((a, b) => b[1].price - a[1].price);
  }

  calculateBaseCoating(baseCoating, area) {
    if (!baseCoating) return { variants: [] };

    let requiredUnits = Math.ceil(area / baseCoating.coverage);
    let price = baseCoating.variant.available ? baseCoating.variant.price : 0;

    return {
      variants: [{
        variant_id: baseCoating.variant.variant_id,
        quantity: requiredUnits,
        price,
        base_coat: true
      }]
    };
  }

  calculateAdditionalProducts(additionalProducts, area) {
    let requiredVariants = [];

    additionalProducts.forEach(p => {
      if (!p.coverage || !p.variants) return console.error("Error: Missing product coverage or variants", p);

      let selectedVariants = this.getOptimizedVariantQuantities(area, p.variants, p.coverage);

      selectedVariants.forEach(([variantId, { quantity, price }]) => {
        requiredVariants.push({ variant_id: variantId, quantity, price });
      });
    });

    return { variants: requiredVariants };
  }

  calculatePigment(pigments, coatingBagQuantity) {
    if (!Array.isArray(pigments) || pigments.length === 0 || coatingBagQuantity === 0)
      return { variants: [] };

    let requiredVariants = [];
    pigments.forEach(pigment => {
      if (!pigment || !pigment.variants || !pigment.pigment_amount) return;

      let totalPigmentRequired = coatingBagQuantity * pigment.pigment_amount;
      let remainingPigment = totalPigmentRequired;

      let sortedVariants = pigment.variants
        .map(v => ({ ...v, numericSize: parseFloat(v.size.match(/[\d.]+/)[0]) || 0 }))
        .sort((a, b) => b.numericSize - a.numericSize);

      for (let v of sortedVariants) {
        if (remainingPigment <= 0) break;

        let quantityNeeded = Math.floor(remainingPigment / v.numericSize);
        if (quantityNeeded > 0) {
          let existingVariant = requiredVariants.find(rv => rv.variant_id === v.variant_id);

          if (existingVariant) {
            existingVariant.quantity += quantityNeeded;
          } else {
            requiredVariants.push({
              variant_id: v.variant_id,
              quantity: quantityNeeded,
              price: v.available ? v.price : 0,
              pigment: true
            });
          }

          remainingPigment -= quantityNeeded * v.numericSize;
        }
      }

      if (remainingPigment > 0) {
        let smallestVariant = sortedVariants.at(-1);
        let extraQuantity = Math.ceil(remainingPigment / smallestVariant.numericSize);
        let existingVariant = requiredVariants.find(rv => rv.variant_id === smallestVariant.variant_id);

        if (existingVariant) {
          existingVariant.quantity += extraQuantity;
        } else {
          requiredVariants.push({
            variant_id: smallestVariant.variant_id,
            quantity: extraQuantity,
            price: smallestVariant.available ? smallestVariant.price : 0,
            pigment: true
          });
        }
      }
    });

    return { variants: requiredVariants };
  }

  calculate(e) {
    if (e) {
      e.preventDefault();
    }
    if (!this.desiredTemplate) return;
    this.requiredVariants = [];

    this.area = this.calculatorInput.value.trim();
    const unit = this.activeUnit;
    this.data = JSON.parse(this.desiredTemplate.dataset.options);
    convertedArea = this.convertAreaToMeters(this.area, unit, "m²")
    let coatingBagQuantity = 0;
    if (this.area === '') {
      if (this.data.base_coating) {
        this.area = this.convertAreaToMeters(this.data.base_coating.coverage, "m²", unit);
        convertedArea = this.data.base_coating.coverage;
      } else {
        this.area = 3.5;
        convertedArea = 3.5;
      }
      this.element.querySelector('.calculator__totals').setAttribute('aria-hidden', true);
    } else {
      this.element.querySelector('.calculator__totals').setAttribute('aria-hidden', false);
    }

    if (this.data.base_coating) {
      let baseCoatingData = this.calculateBaseCoating(this.data.base_coating, convertedArea);
      this.requiredVariants.push(...baseCoatingData.variants);
      coatingBagQuantity = baseCoatingData.variants.length > 0 ? baseCoatingData.variants[0].quantity : 0;
    }

    if (this.data.additional_products) {
      let additionalProductData = this.calculateAdditionalProducts(this.data.additional_products, convertedArea);
      this.requiredVariants.push(...additionalProductData.variants);
    }

    if (this.data.pigments) {
      const pigmentData = this.calculatePigment(this.data.pigments, coatingBagQuantity);
      this.requiredVariants.push(...pigmentData.variants);
    }

    this.renderUIElements();
  }

  recalculatePigment(coatingBagQuantity) {
    if (!this.data.pigments) return;

    const pigmentData = this.calculatePigment(this.data.pigments, coatingBagQuantity);

    pigmentData.variants.forEach(newVariant => {
      const existingIndex = this.requiredVariants.findIndex(v => v.variant_id === newVariant.variant_id);
      if (existingIndex !== -1) {
        this.requiredVariants[existingIndex] = newVariant;
      } else {
        this.requiredVariants.push(newVariant);
      }
    });
  }

  renderUIElements(totalPrice = 0) {
    this.requiredVariants.forEach(variant => {
      totalPrice += (variant.price || 0) * (variant.quantity || 0);
    });

    if (totalPrice === 0) {
      this.atcButton.setAttribute("disabled", "disabled");
      this.atcButtonInner.innerHTML = window.variantStrings.soldOut;
    } else {
      this.atcButton.removeAttribute("disabled");
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='product-module__atc-price u-pb1'> - " +
          Shopify.formatMoney(
            totalPrice,
            window.theme.moneyFormat
          );
        +"</span>";
      } else {
        var priceElement = "";
      }

      this.atcButtonInner.innerHTML = window.variantStrings.addToCart + priceElement;
    }
    let pricePerUnit = totalPrice / this.area;

    this.appendVariantInputs();

    this.requiredVariants.forEach(variant => {
      let inputField = this.element.querySelector(`input[data-variant-id="${variant.variant_id}"]`);
      if (inputField) inputField.value = variant.quantity;
    });

    this.element.querySelectorAll('.additional-product').forEach(product => {
      let variantId = product.getAttribute('data-variant-id');
      let isRequired = this.requiredVariants.some(variant => variant.variant_id == variantId);

      product.style.display = isRequired ? 'flex' : 'none';
    });

    this.element.querySelectorAll('.area__variant-input').forEach(input => {
      let variantId = input.dataset.id;
      let matchingVariant = this.requiredVariants.find(variant => variant.variant_id == variantId);

      if (matchingVariant) input.dataset.quantity = matchingVariant.quantity;
      else input.remove();
    });

    this.element.querySelector('.calculator__cpu-price').innerHTML = Shopify.formatMoney(pricePerUnit, window.theme.moneyFormat);
    if (this.atcPriceSpan) {
      this.atcPriceSpan.innerHTML = ' - ' + Shopify.formatMoney(totalPrice, window.theme.moneyFormat);
    }
    this.element.querySelector('.calculator__subtotal-price').innerHTML = Shopify.formatMoney(totalPrice, window.theme.moneyFormat);
  }



  followInputValue() {
    const value = this.calculatorInput.value.trim();
    this.calculatorUnit.setAttribute("aria-hidden", value.length === 0 ? "true" : "false");

    this.span.textContent = value;

    const inputWidth = this.calculatorInput.offsetWidth;
    const maxAllowedWidth = inputWidth - 40;

    let textWidth = this.span.offsetWidth;

    textWidth = Math.min(textWidth, maxAllowedWidth);
    this.calculatorUnit.style.left = `${textWidth}px`;

    requestAnimationFrame(() => {
      setTimeout(() => {

        let textWidth = this.span.offsetWidth;

        textWidth = Math.min(textWidth, maxAllowedWidth);
        this.calculatorUnit.style.left = `${textWidth}px`;

      }, 25);

    });

    const url = new URL(window.location);
    if (value.length > 0) {
      url.searchParams.set("calculate", value);
    } else {
      url.searchParams.delete("calculate");
    }
    window.history.replaceState({}, "", url.toString());
  }

  getRequiredVariants() {
    return this.requiredVariants;
  }

  toggleUnit(e, target) {
    const unit = target.dataset.unit;
    this.activeUnit = unit;

    target.parentElement.querySelector('[aria-selected="true"]')?.setAttribute('aria-selected', false);
    target.setAttribute('aria-selected', true);

    document.querySelectorAll('.calculator__cpu-unit').forEach(span => span.innerHTML = unit);
    this.element.querySelector('.calculator__input').placeholder = unit;
    this.calculatorUnit.value = unit;

    const url = new URL(window.location);
    url.searchParams.set("unit", unit);
    window.history.replaceState({}, "", url.toString());

    this.element.querySelector('.calculator__button')?.click();
  }

  selectAdditional(e, target) {
    if (!target) {
      this.element.querySelector('.calculator__summary-active')?.setAttribute('aria-hidden', true);
      return;
    }

    const id = target.nextElementSibling.getAttribute('aria-controls');

    if (this.bannerSwiper) {
      const slide = this.bannerSwiper.querySelector(`.swiper-slide[data-area="${id}"]`);
      if (slide) {
        this.bannerSwiper.swiper.slideTo(slide.dataset.index);
      }
    }

    this.desiredTemplate = this.areaTemplates.querySelector(`#${id}`);
    const templateContent = this.desiredTemplate.content.cloneNode(true);
    const productsContainer = this.element.querySelector('.calculator__products');

    const url = new URL(window.location);
    url.searchParams.set('area', id);

    history.replaceState(null, '', url.toString());

    const products = templateContent.querySelector('.area__additional-products');

    this.element.querySelector('.calculator__summary')?.setAttribute("aria-hidden", false);

    if (products && productsContainer) {
      productsContainer.innerHTML = "";
      productsContainer.appendChild(products);
    } else {
      return;
    }

    this.appendVariantInputs();

    this.atcButton.setAttribute('aria-hidden', false);
    this.completePurchaseButton.setAttribute('aria-hidden', true);
    this.calculate(e);
    this.element.querySelector('.calculator__summary-active')?.setAttribute('aria-hidden', false);
    this.element.querySelector('.calculator__summary-change').innerHTML = document.querySelector('input[data-area]').dataset.area + " " + document.querySelector('.area__option-input:checked').dataset.value + " " + window.theme.bundle;
  }

  appendVariantInputs(template = this.desiredTemplate) {
    const templateContent = template.content.cloneNode(true);
    const inputs = templateContent.querySelectorAll('[name="id"]');

    if (inputs) {
      let productForm = this.element.querySelector('form[data-product-form]');
      productForm.querySelectorAll('[name="id"]:not([data-original])').forEach(input => input.remove());
      let validInputs = [...inputs].filter(input => input.getAttribute('aria-enabled') !== "false");
      validInputs.forEach(input => productForm.appendChild(input.cloneNode(true)));
    }
  }

  toggleTemplate(e, target) {
    if (!target) return;

    const oldTarget = this.element.querySelector('[data-action="toggle-template"][aria-expanded="true"]');
    if (e === 'first') {
      target.style.transition = 'none';
      if (oldTarget) oldTarget.style.transition = 'none';
    }

    if (oldTarget) oldTarget.setAttribute("aria-expanded", false);
    target.setAttribute("aria-expanded", true);

    requestAnimationFrame(() => {
      if (e === 'first') {
        target.offsetHeight;
        oldTarget.offsetHeight;
        target.style.transition = '';
        oldTarget.style.transition = '';
      }
    })

    this.element.querySelectorAll('.product-options__container').forEach(container => container.remove());

    const id = target.getAttribute('aria-controls');
    const url = new URL(window.location);
    url.hash = id;
    history.replaceState(null, null, url.toString());

    this.buyButtons?.setAttribute("aria-hidden", "false");
    const templateElement = this.element.querySelector(`#${id}`);
    if (templateElement && templateElement.tagName === "TEMPLATE") {
      const templateHTML = templateElement.innerHTML.trim();
      if (this.areaOptions) this.areaOptions.insertAdjacentHTML("afterend", templateHTML);
    }

    if (id === 'contactForm') {
      this.atcButton.dataset.action = "add-to-cart";
      this.buyButtons?.setAttribute("aria-hidden", "true");
      this.areaOptions?.setAttribute("aria-hidden", "true");
      this.areaOptions?.querySelector(".product-module__selector-label")?.setAttribute('aria-hidden', 'true');
    } else if (id === 'calculator') {
      this.calculatorInput = this.element.querySelector('[name="calculator"]');
      this.calculatorUnit = this.element.querySelector('.calculator__input-unit');
      const urlParams = new URLSearchParams(window.location.search);
      this.calculatorInput.value = urlParams.get("calculate") || "";
      if (this.calculatorInput.value != "") this.followInputValue();
      const unit = urlParams.get("unit") || "";
      if (unit) { this.element.querySelector(`[data-action="toggle-unit"][data-unit=${unit}]`)?.click(); }
      this.selectAdditional(null, this.element.querySelector('.area__option-input:checked'));
      if (this.element.querySelector('.area__option-input:checked')) {
        this.element.querySelector('.calculator__summary')?.setAttribute("aria-hidden", false);
        this.atcButton.setAttribute('aria-hidden', false);
      } else {
        this.atcButton.setAttribute('aria-hidden', true);
        this.completePurchaseButton.setAttribute('aria-hidden', false);
      }
      this.altButtons.forEach(btn => btn.setAttribute('aria-hidden', true));
      this.atcButton.classList.remove('add-all');
      this.quantityInput.setAttribute('aria-hidden', true);
      this.atcButton.dataset.action = "add-all-to-cart";
      this.notifyButtons.forEach(btn => btn.setAttribute('aria-hidden', true));
      this.areaOptions?.setAttribute("aria-hidden", "false");
      this.areaOptions?.querySelector(".product-module__selector-label")?.setAttribute('aria-hidden', 'false');
    } else {
      if (this.atcButton.classList.contains('add-all')) {
        this.atcButton.dataset.action = "add-all-to-cart";
      } else {
        this.atcButton.dataset.action = "add-to-cart";
      }
      this.areaOptions?.setAttribute("aria-hidden", "true");
      this.areaOptions?.querySelector(".product-module__selector-label")?.setAttribute('aria-hidden', 'true');
      this.atcButton.setAttribute('aria-hidden', false);
      this.completePurchaseButton.setAttribute('aria-hidden', true);
      const variantSelects = this.element.querySelector('variant-selects');
      if (variantSelects && variantSelects.showNotifyMeButton) variantSelects.showNotifyMeButton();
      this.altButtons.forEach(btn => btn.setAttribute('aria-hidden', false))
      this.quantityInput.setAttribute('aria-hidden', false);
    }

    this.updateLabels();
  }

  showStickyAtc() {
    const footer = document.querySelector("footer");
    const mainButton = this.element.querySelector(".product-module__atc-button--main");

    if (
      window.scrollY + window.innerHeight <
      footer.getBoundingClientRect().top + window.scrollY &&
      window.scrollY >
      mainButton.getBoundingClientRect().bottom + window.scrollY
    ) {
      this.stickyPopup.setAttribute("aria-hidden", false);
    } else {
      this.stickyPopup.setAttribute("aria-hidden", true);
    }
  }

  async reloadWithoutRefresh() {
    let pdpUrls = this.element.querySelectorAll(
      '[data-action="handle-reload"]'
    );
    let urlsToFetch = Array.from(pdpUrls).map((link) => link.href);

    const fetchAndCacheContent = async (url) => {
      try {
        const response = await fetch(url);

        if (response.ok) {
          const htmlContent = await response.text();
          contentCache[url] = new DOMParser()
            .parseFromString(htmlContent, "text/html")
            .querySelector(".section__product-module");
        } else {
          console.error("Error fetching data. HTTP status:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    await Promise.all(urlsToFetch.map(fetchAndCacheContent));

    const preloadImages = (container) => {
      const images = container.querySelectorAll(
        ".preload-image"
      );
      images.forEach((img) => {
        const preloadedImage = new Image();
        preloadedImage.src = img.getAttribute("src");
        const preloadedQualityImage = new Image();
        preloadedQualityImage.src = img.getAttribute("data-original-src");
      });
    };

    Object.values(contentCache).forEach(preloadImages);
  }

  reloadPage(e) {
    // Check if this is a back navigation (popstate triggered)
    if (this.lock) return;
    window.location.reload();
  }

  updateContentWithoutReload(e) {
    e.preventDefault();
    const url = e.target.href;

    const htmlContent = contentCache[url];
    if (htmlContent) {
      document.title = htmlContent.querySelector('product-component').dataset.title;
      document.querySelector('notify-me-popup')?.remove();
      this.element.querySelectorAll('.product-module__toggle-drawer').forEach(button => document.querySelector(`#${button.dataset.toggleId}`)?.remove());
      document.body.querySelector(`.section__product-module`).innerHTML =
        htmlContent.innerHTML;

      if (window.jdgm) {
        jdgm.loadJS(jdgm.CDN_HOST + "loader.js");
      }

      if (window.GRFQApp && typeof GRFQApp.initialize === "function") {
        GRFQConfigs.selector.productForm = [".product-module__dummy-form"];
        GRFQApp.initialize();
      } else {
        console.warn("GRFQApp is not defined or doesn't have an initialize function.");
      }

      document.body.dispatchEvent(
        new CustomEvent("recommendations:reload", {
          bubbles: true,
          detail: htmlContent.querySelector('.product-module').dataset.productId
        })
      );

      Shopify.PaymentButton.init();
      // Optionally, update the URL in the address bar without a full page reload
      this.updateURL(url);
    } else {
      window.location.href = url;
    }
  }

  updateURL(hrefValue) {
    const url = new URL(window.location);

    // Preserve only specific parameters
    const preservedParams = ['calculate', 'unit', 'area'];
    const newUrl = new URL(hrefValue);

    preservedParams.forEach(param => {
      if (url.searchParams.has(param)) {
        newUrl.searchParams.set(param, url.searchParams.get(param));
      }
    });

    if (url.hash) {
      newUrl.hash = url.hash;
    }

    // Update URL without adding new params
    history.pushState(null, null, newUrl.toString());
  }

  changeImageQuality() {
    var imagesToReveal = null;
    imagesToReveal = this.element.querySelectorAll(".preload-image");

    imagesToReveal.forEach((image) => {
      if (image !== null) {
        const replaceUrl = image
          .getAttribute("data-original-src");
        image.src = replaceUrl;
      }
    });
  }
}
customElements.define("product-component", ProductElement);

let selectedVariant = null;
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    const settingsElement = this.element.querySelector('[data-settings]');
    if (settingsElement) {
      this.targetVariants = JSON.parse(settingsElement.dataset.settings);
      this.variantOptionSelector = settingsElement.closest('.product-module__variant-option');
    }

    const dataElement = this.element.querySelector("[data-bag-variants]");
    if (dataElement) {
      this.bagVariants = JSON.parse(dataElement.dataset.bagVariants);
    }

    this.pigmentTemplate = this.element.querySelector("[data-pigment]");
    if (this.pigmentTemplate) {
      this.pigmentData = JSON.parse(this.pigmentTemplate.dataset.pigment);
    }

    this.baseCoatId = this.element.querySelector("[data-base-coat]")?.dataset.baseCoat;


    this.atcButton = document.querySelector(".product-module__atc-button--main");
    this.notifyButtons = document.querySelectorAll(".product-module__notify-button");
    this.stickyButton = document.querySelector(".product-module__sticky-button");
    this.notifyMeEnabled = document.querySelector("notify-me-popup");
    this.baseCoatId = this.element.querySelector("[data-base-coat]")?.dataset.baseCoat;
    this.productModule = this.element.closest('product-component');


    this.getVariantIdFromUrl();
    this.setOptions();
    this.bindEvents();
    this.onVariantChange();
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    this.delegateElement.on(
      "change",
      '[data-action="select-variant"]',
      this.onVariantChange.bind(this)
    );
  }

  getVariantIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get("variant");

    if (!variantId) return;

    if (!this.variantData) {
      this.variantData = this.getVariantData();
    }

    selectedVariant = this.variantData.find(variant => variant.id.toString() === variantId) || null;
  }

  setOptions() {
    if (!selectedVariant) return;

    selectedVariant.options.forEach(optionValue => {
      const matchingInput = this.querySelector(`input[value="${optionValue}"]`);
      if (matchingInput) {
        matchingInput.checked = true;
      }
    });
  }

  showNotifyMeButton(available = selectedVariant.available) {
    if (!this.notifyMeEnabled) return;

    if (available) {
      this.atcButton.setAttribute('aria-hidden', false);
      this.stickyButton.setAttribute('aria-hidden', false);
      this.notifyButtons.forEach(btn => btn.setAttribute('aria-hidden', true));
    } else {
      this.atcButton.setAttribute('aria-hidden', true);
      this.stickyButton.setAttribute('aria-hidden', true);
      this.notifyButtons.forEach(btn => btn.setAttribute('aria-hidden', false));
    }
  }

  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();

    this.updateMedia();
    this.updateURL();

    if (this.baseCoatId && this.bagVariants && this.pigmentData && this.bagVariants.includes(selectedVariant.id)) {
      this.selectBaseCoatInstead();
      return;
    } else {
      this.atcButton.dataset.action = "add-to-cart";
      this.atcButton.classList.remove('add-all');
      document.querySelectorAll('form[data-product-form] [name="id"]:not([data-original])').forEach(input => input.remove());
    }
    this.updateVariantInput();
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(
        ".variant-option__item-input:checked"
      ),
      (select) => select.value
    );
  }

  areArraysEqual(arrayOne, arrayTwo) {
    if (arrayOne.length !== arrayTwo.length) {
      return false;
    }

    const sortedArrayOne = arrayOne.slice().sort();
    const sortedArrayTwo = arrayTwo.slice().sort();

    return sortedArrayOne.every(
      (value, index) => value === sortedArrayTwo[index]
    );
  }

  isSubset(subset, array) {
    return subset.every((element) => array.includes(element));
  }

  updateMasterId() {
    selectedVariant = this.getVariantData().find((variant) => {
      if (this.areArraysEqual(this.options, variant.options)) {
        return true;
      }

      return this.isSubset(this.options, variant.options);
    });

    if (this.variantOptionSelector) {
      if (this.targetVariants.includes(selectedVariant.id.toString())) {
        this.variantOptionSelector.setAttribute('aria-hidden', false);
      } else {
        this.variantOptionSelector.setAttribute('aria-hidden', true);
      }
    }
  }

  selectBaseCoatInstead() {
    if (!(this.baseCoatId && this.bagVariants && this.pigmentData && this.bagVariants.includes(selectedVariant.id))) {
      return;
    }
    this.updateVariantInput(this.baseCoatId);
    let quantity = 1;
    const quantityEl = document.querySelector(".product-module__buy-buttons .product-module__quantity-input");
    if (quantityEl) {
      quantity = quantityEl.value
    }
    this.atcButton.dataset.action = "add-all-to-cart";
    this.atcButton.classList.add('add-all');
    const pigmentData = this.productModule.calculatePigment(this.pigmentData.pigments, quantity);

    if (pigmentData.variants.length > 0) {
      this.productModule.appendVariantInputs(this.pigmentTemplate);
      pigmentData.variants.forEach(variant => {
        let inputField = this.productModule.querySelector(`input[data-id="${variant.variant_id}"]`);
        if (inputField) inputField.dataset.quantity = variant.quantity;
      });
    }
  }

  updateMedia() {
    if (!selectedVariant) return;
    if (!selectedVariant.featured_media) return;

    const newMedia = selectedVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!selectedVariant) return;

    const url = new URL(window.location);

    url.searchParams.set("variant", selectedVariant.id);
    window.history.replaceState({}, "", url.toString());
  }

  updateVariantInput(newId = selectedVariant.id, productId = selectedVariant) {
    const productForm = document.querySelector('[data-product-form]');
    const input = productForm.querySelector('input[name="id"][data-original]');
    input.value = newId;
  }

  toggleAddButton() {
    let quantity = "";
    const addButton = document.querySelectorAll(".product-module__atc-button--main"),
      addButtonInner = document.querySelectorAll(".product-module__atc-button--main .ButtonText"),
      quantityEl = document.querySelector(".product-module__buy-buttons .product-module__quantity-input"),
      altButtons = document.querySelectorAll(".product-module__alt-atc-button");

    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (selectedVariant.available == false) {
      addButton.forEach(button => button.setAttribute("disabled", "disabled"));
      addButtonInner.forEach((btn) => {
        btn.innerHTML = window.variantStrings.soldOut;
      });
      altButtons.forEach(button => button.setAttribute("disabled", ""));
    } else {
      altButtons.forEach(button => button.removeAttribute("disabled"));
      addButton.forEach(button => button.removeAttribute("disabled"));
      if (window.variantInfo.show_price) {
        var priceElement =
          "<span class='product-module__atc-price u-pb1'> - " +
          Shopify.formatMoney(
            selectedVariant.price * quantity,
            window.theme.moneyFormat
          );
        +"</span>";
      } else {
        var priceElement = "";
      }

      addButtonInner.forEach((btn) => {
        btn.innerHTML = window.variantStrings.addToCart + priceElement;
      });
    }

    this.showNotifyMeButton(selectedVariant.available);
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }



}
customElements.define("variant-selects", VariantSelects);

class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');

    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.pageOverlayElement = this.element.querySelector(".sectionOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector('.searchInput--clear');
    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }
    this.headerTransparent = false;
    this.carouselElement = this.element.querySelector(".searchInitialView");
    if (this.carouselElement) {
      if (responsive.matchesBreakpoint("lap_and_up")) {
        this.carousel = new RevolutionSwiper(this.carouselElement);
      }
    }

    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );


    this.bindEvents();
  }


  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );
    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  initCarousel() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      var carousel = this.searchResultsElement.querySelector(
        "[data-swiper-settings]"
      );
      if (carousel) {
        this.newCarousel = new RevolutionSwiper(carousel);
      }
    }
  }

  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    event.preventDefault();

    const _this = this;
    // Check if search is already open, close it if true
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    this.element.style.display = "block";

    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    // Check if search element exists
    if (!this.element) {
      console.error('Search element not found');
      return;
    }

    // Show search element and page overlay
    const search = document.querySelector("#quickSearch");
    if (search) {
      search.setAttribute("aria-hidden", false);
    }
    this.pageOverlayElement.classList.add("is-visible");
    // Disable scrolling on body
    bodyScrollLock.disableBodyScroll(
      this.element.querySelector('[data-scrollable]'),
      bodyScrollLockOptions
    );
    document.body.classList.add("scrollLock");

    // Focus on search input element after delay
    setTimeout(() => {
      if (_this.searchInputElement) {
        _this.searchInputElement.focus();
      }
    }, 200);


    if (document.querySelector('.Header--Transparent')) {
      setTimeout(() => {
        const header = document.body.querySelector("#header");
        if (header) {
          header.classList.remove("Header--Transparent");
        }
      }, 15);
      this.headerTransparent = true;
    }


    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }
  }

  closeSearch() {
    event.preventDefault();

    if (!this.isOpen) {
      return;
    }
    document.body.classList.remove("scrollLock");
    bodyScrollLock.enableBodyScroll(this.element.querySelector('[data-scrollable]'), bodyScrollLockOptions);
    this.element.setAttribute('aria-hidden', true);
    const transitionElement = this.element.querySelector('.searchInnerWrapper');

    const transitionEndHandler = () => {
      if (this.headerTransparent && this.headerTransparent) {
        document.body
          .querySelector("#header")
          .classList.add("Header--Transparent");
      }
      this.element.style.display = "none";
      transitionElement.removeEventListener('transitionend', transitionEndHandler);
    };

    transitionElement.addEventListener('transitionend', transitionEndHandler);

    this.pageOverlayElement.classList.remove("is-visible");


    this.isOpen = false;
  }


  async onInput(event) {
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute('aria-hidden', 'false');
    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".searchInput");

      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
    } else {
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    try {
      const response = await fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.lastInputValue)}&resources[limit_scope]=each&section_id=search-predictive`);

      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      const text = await response.text();
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-search-predictive').innerHTML;

      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
      const div = document.createElement('div');
      div.innerHTML = resultsMarkup;

      const suggestedQueries = div.querySelector('template');
      const currentSuggestedQueries = this.element.querySelector('.predictiveSearch--queries');
      const currentRecentQueris = this.element.querySelector('#predictiveSearch--recentSearches');


      this.searchResultsElement.innerHTML = resultsMarkup;
      this.initCarousel();

      if (suggestedQueries) {
        if (currentRecentQueris) {
          currentRecentQueris.remove();
        }

        if (currentSuggestedQueries) {
          currentSuggestedQueries.remove();
        }
        const node = suggestedQueries
          .content.firstElementChild.cloneNode(true);
        this.searchResultsElement.prepend(node);
      }


      this.searchResultsElement.style.opacity = 1;

      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }
    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }

      throw error;
    }

  }

  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    const currentSuggestedQueries = this.element.querySelector('.predictiveSearch--queries');
    if (currentSuggestedQueries) currentSuggestedQueries.remove();
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

    if (window.theme.showRecentSearches) { this.getRecentSearches(); }
    this.initCarousel();
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute('aria-hidden', 'true');
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) { }
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let elementToAdd = this.element.querySelector(
      ".search--recentResults"
    );
    if (items.length > 0) {
      items.forEach((id) => {
        appendString =
          appendString +
          "<li role='option' tabIndex='0' class='hoverLinks' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      elementToAdd.innerHTML = appendString;
    } else {
      this.querySelector('#predictiveSearch--recentSearches').style.display = "none";
    }
  }

}
customElements.define("search-bar", SearchBar);

class TermsAndConditions extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
  }

  bindEvents() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if (!isMobile) scrollListener.addScrollListener(this, stickyLinksTopPadding.bind(this));
  }
}

customElements.define("terms-and-conditions", TermsAndConditions);

class BlogPage extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.bindEvents();

    new InfiniteScroll('#blog-grid-layout', '#infinite-scroll', true);
  }

  bindEvents() {
    const isMobile = responsive.matchesBreakpoint("pocket");
    if (!isMobile) scrollListener.addScrollListener(this, stickyLinksTopPadding.bind(this));
  }
}

customElements.define("blog-section", BlogPage);


class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    const isMobile = responsive.matchesBreakpoint("pocket");
    if (!isMobile) scrollListener.addScrollListener(this, stickyLinksTopPadding.bind(this));
  }

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
    } else {
      this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
    }
  }
}

customElements.define("contact-section", ContactSection);


class faqSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.searchInput = this.element.querySelector(".faq--search");
    this.searchBar = this.element.querySelector('.faq_search-bar_wrapper');
    this.termsBlocks = document.querySelectorAll(".FAQ");
    this.noResultsElement = document.querySelector("#faq__results--none");

    this.bindEvents();
  }

  bindEvents() {
    this.onInputListener = debounce(this.handleSearch.bind(this), 350);

    this.delegateElement.on("click", '[data-action="handle-tab-click"]', this.handleTabClick.bind(this));
    this.delegateElement.on("click", '[data-action="clear-search"]', this.clearSearch.bind(this));

    this.delegateElement.on(
      "keyup",
      '[data-action="search-string"]',
      this.onInputListener
    );

    const isMobile = responsive.matchesBreakpoint("pocket");
    if (!isMobile) scrollListener.addScrollListener(this, stickyLinksTopPadding.bind(this));
  }

  handleSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();
    const clearBtn = this.element.querySelector(
      ".supportFaq--mobileClearBtn"
    );
    const searchPlaceholderButton = this.element.querySelector(".supportFaq--searchBtn");
    if (searchPlaceholderButton) searchPlaceholderButton.style.display = this.searchInput.value ? "none" : "flex";
    if (clearBtn) clearBtn.style.display = this.searchInput.value ? "flex" : "none";

    // Reset visibility if search input is empty
    if (searchTerm === "") {
      this.termsBlocks.forEach((block) => {
        block.classList.remove("is-hidden");
        const questions = block.querySelectorAll(".Faq-section_content");
        questions.forEach((content) => content.classList.remove("is-hidden"));
      });
      this.noResultsElement.classList.add("is-hidden");
      return;
    }

    let hasMatch = false;

    this.termsBlocks.forEach((block) => {
      const title = block.querySelector('.faq__block--heading').textContent.toLowerCase();
      const questions = block.querySelectorAll(".Faq-section_content");
      let blockMatch = false;

      if (title.includes(searchTerm)) {
        // If the heading matches, display all content in this block
        block.classList.remove("is-hidden");
        questions.forEach((content) => content.classList.remove("is-hidden"));
        blockMatch = true;
      } else {
        // If only `faq__block-content` matches
        questions.forEach((questionWrapper) => {
          const questionText = questionWrapper.textContent.toLowerCase();
          if (questionText.includes(searchTerm)) {
            questionWrapper.classList.remove("is-hidden");
            blockMatch = true;
          } else {
            questionWrapper.classList.add("is-hidden");
          }
        });

        // Show or hide the block based on matching content
        if (blockMatch) {
          block.classList.remove("is-hidden");
        } else {
          block.classList.add("is-hidden");
        }
      }

      if (blockMatch) hasMatch = true;
    });

    // Display 'no results' message if nothing matched
    if (!hasMatch) {
      this.noResultsElement.classList.remove("is-hidden");
    } else {
      this.noResultsElement.classList.add("is-hidden");
    }
  }

  clearSearch() {
    const clearBtn = this.element.querySelector(".supportFaq--mobileClearBtn");
    const searchPlaceholderButton = this.element.querySelector(".supportFaq--searchBtn");
    const inputValue = this.element.querySelector(".faq--search.mobile");

    // Reset search input
    if (inputValue) inputValue.value = "";

    // Hide elements that should be hidden initially
    if (clearBtn) clearBtn.style.display = "none";
    if (searchPlaceholderButton) searchPlaceholderButton.style.display = "flex";

    // Reset FAQ term sections
    this.termsBlocks.forEach((block) => {
      block.classList.remove("is-hidden");
      const questions = block.querySelectorAll(".Faq-section_content");
      questions.forEach((content) => content.classList.remove("is-hidden"));
    });
    this.noResultsElement.classList.add("is-hidden");
    inputValue.focus();
  }

  handleTabClick(event, target) {
    event.preventDefault();

    const targetId = target.getAttribute('href').substring(1);
    const newUrl = `${window.location.pathname}#${targetId}`;
    history.pushState(null, null, newUrl);

    const targetElement = this.element.querySelector(`#${targetId}`);

    if (targetElement) {
      this.scrollToSection(targetElement);
    }
  }

  scrollToSection(targetElement) {
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height-fixed')) || 0;
    let offset = headerHeight + 16;
    if (responsive.matchesBreakpoint('pocket') && this.searchBar) {
      offset = offset + this.searchBar.offsetHeight;
    }
    const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
}

customElements.define("faq-section", faqSection);


class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
    };
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define("localization-form", LocalizationForm);


class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));

    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("popup-seen");

    if (this.options.show_only_once && localKey === "true") return;

    if (this.options.scroll_amount > 0) {
      this.myScrollListener = scrollListener.addScrollListener(this, this.scrollListener);
    } else {
      this.openNewsletter();
    }

  }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  onTransitionEnd(event) {
    if (event.propertyName === "opacity") {
      if (this.element.getAttribute("aria-hidden") === "true") {
        this.element.style.display = "none";
        document.body.classList.remove("scrollLock");
        this.pageOverlayElement.classList.remove("is-visible");
        bodyScrollLock.enableBodyScroll(this.element);

        this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);
        this.element.removeEventListener("transitionend", this.onTransitionEnd.bind(this));
      }


    }
  }

  openNewsletter() {
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
    setTimeout(() => {
      this.element.style.display = "block";

      requestAnimationFrame(() => {

        this.element.setAttribute("aria-hidden", "false");
      });

      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = () => {
    this.element.addEventListener("transitionend", this.onTransitionEnd.bind(this));
    this.element.setAttribute("aria-hidden", true);



    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
  };
}

customElements.define("newsletter-popup", NewsletterPopup);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector('#accountDrawer'));
    this.bindEvents();

  }
  bindEvents() {

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on('click', '[data-action="submit-recovery"]', this.accountRecover.bind(this));
  }

  toggleRecovery() {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id == 'recoverFlex') {
      this.element.querySelector('#recoverFlex').setAttribute('aria-visible', 'true');
      this.element.querySelector('#loginFlex').setAttribute('aria-visible', 'false');
    }
    else {
      this.element.querySelector('#recoverFlex').setAttribute('aria-visible', 'false');
      this.element.querySelector('#loginFlex').setAttribute('aria-visible', 'true');
    }
  }

  accountRecover(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = '/account/login#recover';

    // Create the request body with the registration data
    const requestBody = {
      'email': this.element.querySelector('#RecoverEmail').value
    };

    event.target.querySelector('.ButtonText').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        const responseText = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = responseText;

        if (responseText.indexOf('RecoverEmail-email-error') !== -1) {

          _this.element.querySelector('#recoverFlex .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('#RecoverEmail-email-error').innerHTML;
        } else if (responseText.indexOf('recoverSuccess') !== -1) {


          _this.element.querySelector('#recoverFlex .accountDrawer--SuccessSpace').innerHTML = tempDiv.querySelector('#recoverSuccess').innerHTML;
        }

        event.target.querySelector('.button--text').style.visibility = "visible";
        event.target.querySelector('.itemLoader').classList.remove('is-visible');


      } catch (error) {
        console.error('An error occurred during the registration request:', error);
      }
    })();
  }


  submitRegistration(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = '/account';

    // Create the request body with the registration data
    const requestBody = {
      'customer': {
        'first_name': this.element.querySelector('#register #RegisterForm-FirstName').value,
        'last_name': this.element.querySelector('#register #RegisterForm-LastName').value,
        'email': this.element.querySelector('#register #RegisterForm-email').value,
        'password': this.element.querySelector('#register #RegisterForm-password').value
      }
    };

    event.target.querySelector('.ButtonText').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        const responseText = await response.text();

        if (responseText.indexOf('registerErrors') !== -1) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = responseText;

          _this.element.querySelector('#register .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.registerErrors').innerHTML;
        } else {
          location.href = window.routes.account_url;
        }

        event.target.querySelector('.ButtonText').style.visibility = "visible";
        event.target.querySelector('.itemLoader').classList.remove('is-visible');


      } catch (error) {
        console.error('An error occurred during the registration request:', error);
      }
    })();
  }


  submitLogin(event) {
    event.preventDefault();
    const _this = this;
    const loginEndpoint = '/account/login';

    // Create the request body with the login credentials
    const requestBody = {
      'customer': {
        'email': this.element.querySelector('#customer_login #CustomerEmail').value,
        'password': this.element.querySelector('#customer_login #CustomerPassword').value
      }
    };

    event.target.querySelector('.ButtonText').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(loginEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });


        const responseText = await response.text();

        if (responseText.indexOf('loginError') !== -1) {
          console.error('Incorrect email or password');
          const tempDiv = document.createElement('div');

          tempDiv.innerHTML = responseText;

          _this.element.querySelector('#login .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.AlertError').innerHTML;
          event.target.querySelector('.ButtonText').style.visibility = "visible";
          event.target.querySelector('.itemLoader').classList.remove('is-visible');
        } else {
          location.href = window.routes.account_url;

        }



      } catch (error) {
        console.error('An error occurred during the login request:', error);
      }
    })();

  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll('.accountDrawer--Tab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.accountContent');

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    event.target.setAttribute('aria-expanded', 'true');

    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }
  }

}

customElements.define("account-handler", AccountHandler);

let alreadyExits = false;
class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    if (!alreadyExits) {

      new Popup(this.element, true);
      alreadyExits = true;
    }
  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class LocalizationModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;
  }

  connectedCallback() {
    this.delegateBody = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
    this.localizationOverlay = document.querySelector(".localizationOverlay");
    this.element.querySelectorAll('.RevolutionSelectbox').forEach(box => new RevolutionSelectbox(box));

    this.bindEvents();
    this.handleOpenOptions();
  }

  bindEvents() {
    this.delegateBody.on("change:countrySelector", this.updateLanguageOptions.bind(this));
    this.delegateElement.on('keydown', '[data-action="select-language"]', this.selectLanguage.bind(this));
  }

  handleOpenOptions() {
    const localKey = localStorage.getItem("localization-popup-seen");

    if (localKey === "true") return;
    this.openLocalizationModal();
  }

  openLocalizationModal() {
    const modal = document.querySelector("#modal-country");

    modal.setAttribute("aria-hidden", false);
    this.localizationOverlay.classList.add("is-visible");

    bodyScrollLock.disableBodyScroll(modal, bodyScrollLockOptions);
    document.body.classList.add("scrollLock");

    this.localizationOverlay.addEventListener("click", () => {
      modal.setAttribute("aria-hidden", true);
      document.body.classList.remove("scrollLock");
      this.localizationOverlay.classList.remove("is-visible");
      bodyScrollLock.enableBodyScroll(modal, bodyScrollLockOptions);
    });

    localStorage.setItem("localization-popup-seen", true);
  }

  selectLanguage(e, target) {
    if (e.key === 'Enter') {
      target.previousElementSibling.checked = true;
    }
  }

  updateLanguageOptions(e) {
    const languagesJSON = e.detail.languages;
    const languages = JSON.parse(languagesJSON);

    const languageSelectbox = this.element.querySelector('.country-selector__dropdown--language .RevolutionSelectbox');
    const languageDropdown = languageSelectbox.querySelector('.RevolutionSelectbox--InnerContent');
    const languageInput = languageSelectbox.querySelector('input');

    const languageSelectboxClone = languageSelectbox.cloneNode(true);
    const selectboxCloneDropdown = languageSelectboxClone.querySelector('.RevolutionSelectbox--InnerContent');
    selectboxCloneDropdown.innerHTML = '';

    let selectedLanguage = null;
    languages.forEach((language) => {
      const selectboxItem = languageDropdown.firstElementChild.cloneNode();
      selectboxItem.dataset.value = language.iso;
      selectboxItem.dataset.name = language.name;
      selectboxItem.textContent = language.name;
      selectboxItem.removeAttribute('selected');

      if (e.detail.country.toLowerCase() === selectboxItem.dataset.value.toLowerCase()) {
        languageInput.value = selectboxItem.dataset.value;
        selectboxItem.setAttribute('selected', 'selected');
        selectedLanguage = language;
      } else {
        selectedLanguage = null;
      }

      selectboxCloneDropdown.appendChild(selectboxItem);
    });

    languageSelectbox.parentElement.replaceChild(languageSelectboxClone, languageSelectbox);

    const newLanguageTitle = languageSelectboxClone.querySelector('.RevolutionSelectbox--Title');
    if (selectedLanguage) {
      newLanguageTitle.innerHTML = selectedLanguage.name;
    }

    new RevolutionSelectbox(languageSelectboxClone);
  }

}
customElements.define("localization-modal", LocalizationModal);


class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.closeButton = this.element.querySelector('.announcement-bar__close');

    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      this.element.clientHeight + "px"
    );

    if (sessionStorage.getItem("annBarHidden", true)) {
      this.element.classList.add("hidden");
    } else {
      this.hideListener = this.hide.bind(this);
    }

    this.updateVisibleHeight();
    this.bindEvents();

    this.announcementItems = this.element.querySelectorAll(
      ".announcement-bar__block"
    );
    this.firstAnnouncementItem = this.element.querySelector(
      ".announcement-bar__block-no-animation"
    );
    if (this.announcementItems.length > 1 && this.options["enableAnimation"]) {
      this.initialize();
    } else {
      this.firstAnnouncementItem.classList.add("base");
    }
  }

  handleAnnBarHide() {
    const footerElement = document.querySelector(".mainfooterWrapper");

    if (footerElement) {
      const footerTop = footerElement.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (footerTop <= windowHeight) {
        this.element.classList.add('hide-ann-bar');
        return;
      }
    }

    const atTheBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 210;
    if (atTheBottom) {
      this.element.classList.add('hide-ann-bar');
    } else {
      this.element.classList.remove('hide-ann-bar');
    }
  }


  initialize() {
    this.currentIndex = 0;
    this.announcementItems[this.currentIndex].classList.add("active");
    this.announcementItems[this.currentIndex].classList.add("is-visible");
    setInterval(this.showNextElement.bind(this), this.options["cycleSpeed"]);
  }

  bindEvents() {
    scrollListener.addScrollListener(this, this.updateVisibleHeight.bind(this));
    scrollListener.addScrollListener(this, this.handleAnnBarHide.bind(this));
    responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));


    if (this.hideListener) {
      this.delegateElement.on(
        'click',
        '[data-action="ann-bar-close"]',
        this.hideListener
      );
    }
  }

  hide() {
    this.element.classList.add("hidden");
    sessionStorage.setItem("annBarHidden", true);
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `0px`
    );
  }

  showNextElement() {
    // Get the current item (which should be the only one with "is-visible")
    const currentItem = this.announcementItems[this.currentIndex];

    // Immediately hide the current item:
    // remove its "active" class (stopping any fade in/out)
    // remove "is-visible" and add "is-hidden" so it's no longer in the visible layout.
    currentItem.classList.remove("active");
    currentItem.classList.remove("is-visible");
    currentItem.classList.add("is-hidden");

    // Calculate the next index and select the incoming item.
    this.currentIndex = (this.currentIndex + 1) % this.announcementItems.length;
    const nextItem = this.announcementItems[this.currentIndex];

    // Update the incoming item’s display state first:
    // Remove the "is-hidden" class and add "is-visible" so it immediately occupies layout space.
    nextItem.classList.remove("is-hidden");
    nextItem.classList.add("is-visible");

    // Now, on the next animation frame, add the "active" class to trigger the fade-in opacity transition.
    void nextItem.offsetWidth;
    requestAnimationFrame(() => {
      nextItem.classList.add("active");
    });


  }



  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }
}
customElements.define("announcement-bar", AnimatedAnnouncementBar);

class CardPopUpContent extends HTMLElement {
  static popupOpenedEvent = false;
  static get observedAttributes() {
    return ["data-variant"];
  }
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.domDelegate = new Delegate(document.body);
    new AddToCart(this.element);

  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-variant") {
      this.onDataAttributeChange(newValue);
    }
  }

  onDataAttributeChange(newValue) {
    const input = this.element.querySelector('[name="id"]');
    if (!input) return;
    input.value = newValue;
  }

  connectedCallback() {

    this.domDelegate.on("popup:opened", this.replaceContent.bind(this));

    this.domDelegate.on(
      "click",
      '[data-action="change-connected-product"]',
      this.onChangeConnectedProduct.bind(this)
    );

    this.titleElement = this.element.querySelector(".cardInformation__variant-name");

    if (this.titleElement) {
      this.ogValue = this.titleElement.textContent;
      this.delegateElement = new Delegate(this.element);
      this.bindEvents();
    }

    CardPopUpContent.popupOpenedEvent = true;

  }
  bindEvents() {
    this.delegateElement.on("mouseenter", '[data-action="hover-color"]', this.updateVariantDetails.bind(this), true);
    this.delegateElement.on("mouseleave", '[data-action="hover-color"]', this.reset.bind(this), true);
  }

  updateVariantDetails(e, target) {
    clearTimeout(this.resetTimer);
    this.titleElement.textContent = target.dataset.variantTitle;
  }

  reset() {
    this.resetTimer = setTimeout(() => {
      this.titleElement.textContent = this.ogValue;
    }, 200);
  }

  replaceContent(event) {
    const templateContent = this.element.querySelector(
      `#product-popup__content--${event.detail.product}`
    );



    if (!templateContent) {
      return;
    }

    const quickPopup = document.querySelector('#product-card-popup');
    const modalHeight = window.innerHeight - 32;

    const clonedContent = templateContent.content.cloneNode(true);
    const contentToInsert = clonedContent.querySelector(
      ".product-popup__inner-content"
    );

    const contentToReplace = document.querySelector(
      ".product-card__popup-scrollable-content"
    );

    if (contentToInsert && contentToReplace) {
      contentToReplace.innerHTML = "";
      contentToReplace.appendChild(contentToInsert.cloneNode(true));
      requestAnimationFrame(() => {
        if (quickPopup.offsetHeight > modalHeight) {
          quickPopup.style.height = `${modalHeight}px `;
        }
      });

    }
  }

  onChangeConnectedProduct(event) {
    event.preventDefault();

    // Get the connected product ID from the clicked element
    const connectedId = event.target.getAttribute("connectedId");
    if (!connectedId) return;

    // Find the corresponding template content
    const templateContent = document.querySelector(
      `#product-popup__content--${connectedId}`
    );

    if (!templateContent) {
      console.warn(`No template content found for connected product ID: ${connectedId}`);
      return;
    }


    const contentToReplace = document.querySelector(".product-card__popup-scrollable-content");

    const clonedContent = templateContent.content.cloneNode(true);
    const contentToInsert = clonedContent.querySelector(".product-popup__inner-content");

    if (contentToInsert) {


      contentToReplace.style.opacity = "0";


      setTimeout(() => {
        // Replace content after fade-out completes
        contentToReplace.innerHTML = "";
        contentToReplace.appendChild(contentToInsert.cloneNode(true));

        contentToReplace.style.opacity = "1";
      }, 300);

    }
  }


}
customElements.define("card-component", CardPopUpContent);


class quickVariants extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.domDelegate = new Delegate(document.body);
    new AddToCart(this.element);
  }

  connectedCallback() {
    if (this.element.closest("card-component")) {
      this.originalElement = this.element.closest("card-component");
    }

    this.productId = this.element.dataset.productId;
    if (this.querySelector('[type="application/json"]')) {
      this.productVariants = JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      );
    }

    this.delegateElement.on(
      "click",
      '[data-action="change-variant"]',
      this.onVariantChange.bind(this)
    );



    this.domDelegate.on("popup:opened", (event) => {
      this.productVariants = event.detail.product_variants;
      this.productId = event.detail.product;
      this.originalElement = document.querySelector(
        `card-component[data-id="${this.productId}"]`
      );

    });
  }




  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateMasterVariant();
    this.toggleAddButton();
    this.updateVariantInput();
    this.changeProductPrice();

  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll(
        ".VariantSelect input:checked"
      ),
      (select) => select.value
    );
  }

  areArraysEqual(arrayOne, arrayTwo) {
    if (arrayOne.length !== arrayTwo.length) {
      return false;
    }

    const sortedArrayOne = arrayOne.slice().sort();
    const sortedArrayTwo = arrayTwo.slice().sort();

    return sortedArrayOne.every(
      (value, index) => value === sortedArrayTwo[index]
    );
  }

  isSubset(subset, array) {
    return subset.every((element) => array.includes(element));
  }

  updateMasterId() {
    this.productVariants = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    this.currentVariant = this.productVariants.find((variant) => {
      if (this.areArraysEqual(this.options, variant.options)) {
        return true;
      }

      return this.isSubset(this.options, variant.options);
    });
  }

  updateMasterVariant() {
    if (!this.originalElement) return;
    this.originalElement.dataset.variant = this.currentVariant.id;
  }

  toggleAddButton(e) {
    const addButton = this.element.querySelector(".ProductCard--instantATC"),
      addButtonInner = this.element.querySelector(
        ".ProductCard--instantATC .ButtonText"
      );

    if (!addButton) return;

    if (this.currentVariant.available == false) {
      addButton.setAttribute("disabled", "disabled");
      addButton.classList.add("ProductCard--Sold__Out");
      addButtonInner.innerHTML = window.variantStrings.soldOut;
    } else {
      addButton.removeAttribute("disabled");
      addButton.classList.remove("ProductCard--Sold__Out");
      addButton.style.display = "flex";

      addButtonInner.innerHTML = window.variantStrings.addToCart;
    }
  }

  changeProductPrice() {
    const productPriceElement = document.querySelector(".product-popup__variant-price");

    productPriceElement.textContent = `${Shopify.formatMoney(this.currentVariant.price, window.theme.moneyFormat)}`;
    if (!productPriceElement || !this.currentVariant || !this.currentVariant.price) return;

    const productVATPrice = document.querySelector(".no-vat-price");
    if (!productVATPrice) return;
    const vatPercentage = parseFloat(productVATPrice.getAttribute("data-vat-percentage"));
    const vatPrice = this.currentVariant.price - (this.currentVariant.price * (vatPercentage / 100));

    productVATPrice.textContent = `${Shopify.formatMoney(vatPrice, window.theme.moneyFormat)}`;
  }



  updateVariantInput() {
    const input = this.element.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }
}
customElements.define("quick-variants", quickVariants);

new Popup(document.querySelector(`#product-card-popup`));

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.delegateBody = new Delegate(document.body);
    this.carouselElement = this.querySelector(".product-recommendations__swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);
    new AddToCart(this.element)
  }

  connectedCallback() {
    this.delegateBody.on('recommendations:reload', this.reloadRecommendations.bind(this));
    this.loadRecommendations(this.dataset.url);
  }

  reloadRecommendations(e) {
    const productId = e.detail;
    const url = this.dataset.urlTemplate.replace("PRODUCT_ID", productId);
    this.loadRecommendations(url);
  }

  async loadRecommendations(url) {
    try {
      const response = await fetch(url);
      const text = await response.text();

      const html = new DOMParser().parseFromString(text, "text/html");

      const newSwiper = html.querySelector(".product-recommendations__swiper");
      const oldSwiper = this.element.querySelector(".product-recommendations__swiper");
      oldSwiper.swiper.destroy();

      if (newSwiper) {
        oldSwiper.parentElement.replaceChild(newSwiper, oldSwiper);
        new RevolutionSwiper(newSwiper);
      }
    } catch (e) {
      console.error(e);
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);



class BlogShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.breakpoint = responsive.getCurrentBreakpoint();
    this.isDesktop = this.breakpoint === 'desktop';

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      try {
        const swiperElement = this.querySelector('.big-blog__swiper-wrapper .swiper');
        const smallSwiperElement = this.querySelector('.small-blog-showcase');

        if (swiperElement && smallSwiperElement) {

          //Create swiper elements
          const bigSwiper = new RevolutionSwiper(swiperElement).swiperElement;
          const smallSwiper = new RevolutionSwiper(smallSwiperElement).swiperElement;

          //Keep track if both swipers have synced
          //and moved to next slide
          let isChanging = false;

          const startAutoplay = () => {
            if (!bigSwiper && !smallSwiper) return;

            bigSwiper.autoplay.start();
            smallSwiper.autoplay.start();
          }

          const resetSwipers = () => {
            if (!bigSwiper || !smallSwiper) return;

            bigSwiper.params.speed = 2000;
            smallSwiper.params.speed = 1000;

            startAutoplay();
          }

          //IF autoplay is off on both swipers and the swipers
          //are yet to be swiped to next slide
          //slide the swipers to next/prev slide and reset back to autoplay
          const moveBothSlides = (direction) => {
            if (!bigSwiper.autoplay.running || !smallSwiper.autoplay.running && !isChanging) {
              isChanging = true;

              bigSwiper.params.speed = 1000;
              smallSwiper.params.speed = 1000;

              if (direction === "next") {
                bigSwiper.slideNext();
                smallSwiper.slideNext();
              } else {
                bigSwiper.slidePrev();
                smallSwiper.slidePrev();
              }

              // --- Reset swipers back to autoplay --- // 
              isChanging = false;
              resetSwipers();
            }
          };

          bigSwiper.on('slideChange', () => {
            //IF autoplay is off and slidechange event happened
            //IF both swipers are visible (e.g Desktop view)
            //sync swipers and move them to the next slide
            //ELSE run autoplay for mobile view

            if (!bigSwiper.autoplay.running && !isChanging) {
              this.isDesktop ? debounce(moveBothSlides("next"), 300) : setTimeout(() => { startAutoplay(); }, 100)
            }
          }
          );

          smallSwiper.on('slideChange', () => {
            if (!smallSwiper.autoplay.running && !isChanging) {
              if (this.isDesktop) debounce(moveBothSlides("next"), 300);
            }
          });

          const nextButton = smallSwiperElement.querySelector('.nextEl');
          const prevButton = smallSwiperElement.querySelector('.prevEl');

          if (nextButton) {
            nextButton.addEventListener('click', () => {
              //IF desktop move both swipers
              //ELSE start back autoplay
              this.isDesktop ? debounce(moveBothSlides("next"), 300) : startAutoplay();
            });
          }

          if (prevButton) {
            prevButton.addEventListener('click', () => {
              this.isDesktop ? debounce(moveBothSlides("prev"), 300) : startAutoplay();
            });
          }
        } else {
          console.error("Swiper element not found.");
        }
      } catch (e) {
        console.error("Error initializing Swiper:", e);
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.5,
    });

    observer.observe(this);
  }
}

customElements.define("blog-showcase", BlogShowcase);

class UspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const swiper = this.element.querySelector(".usp-swiper");
      new RevolutionSwiper(swiper);
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "-100px 0px 200px 0px",
    }).observe(this);
  }
}

customElements.define("usp-section", UspSection);


class MainSearch extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.searchTypes = [
      { id: "collection__main-grid", type: "product" },
      { id: "collection__main-grid-articles", type: "article" },
    ];
  }

  connectedCallback() {
    this.filterBar = this.element.querySelector(".collection__header");
    this.loadType = this.element.dataset.load;

    new AddToCart(this.element);
    this.delegateElement = new Delegate(this.element);

    this.bindEvents();
    this.initialize();
  }

  initialize() {
    if (this.loadType === "scroll") {
      this.bindObservers();
    } else {
      this.delegateElement.on("click", '[data-action="load-initial"]', this.handleClick.bind(this));
    }

    if (window.location.pathname.includes('/view/article-primary')) {
      this.toggleGridBasedOnUrl();
    }
  }

  bindEvents() {
    this.delegateElement.on("click", '[data-action="toggle-collection"]', this.toggleGrid.bind(this));
    window.addEventListener("popstate", this.toggleGridBasedOnUrl.bind(this));
  }

  bindObservers() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.25,
    };

    this.searchTypes.forEach((searchType) => {
      const container = document.getElementById(searchType.id);
      if (!container) return;
      const paginationElement = container.querySelector(".infinite-scroll");
      if (!paginationElement) return;

      // Select the second-to-last child
      const children = container.children;
      const target = children[children.length - 2];

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paginationElement.remove();
            observer.unobserve(target);

            this.fetchSearchType(searchType.id, searchType.type);
          }
        });
      }, observerOptions);

      observer.observe(target);
    });
  }

  async handleClick(e) {
    e.preventDefault();
    e.target.querySelector(".itemLoader").classList.add("is-visible");
    const paginationElement = e.target.parentElement;

    const matchingObject = this.searchTypes.find(
      (item) => item.type === paginationElement.dataset.type
    );
    await this.fetchSearchType(matchingObject.id, matchingObject.type);

    paginationElement.remove();
  }

  async fetchSearchType(gridContainerId, type) {
    let path = window.location.pathname;

    for (const searchType of this.searchTypes) {
      const pattern = `/view/${searchType.type}s`;
      if (path.includes(pattern)) {
        path = path.replace(pattern, "");
        break;
      }
    }

    const currentUrl = new URL(window.location.href);

    if (type === "article") {
      const paramsToRemove = [];

      for (const param of currentUrl.searchParams.keys()) {
        if (param.startsWith("filter")) {
          paramsToRemove.push(param);
        }
      }

      for (const param of paramsToRemove) {
        currentUrl.searchParams.delete(param);
      }
    }

    currentUrl.searchParams.delete("type");
    currentUrl.searchParams.delete("page");

    currentUrl.searchParams.set("type", type);
    currentUrl.searchParams.set("page", "2");

    const updatedUrl = `${path}?${currentUrl.searchParams.toString()}`;

    await this.renderSectionFromFetch(updatedUrl, gridContainerId);
  }

  async renderSectionFromFetch(url, gridContainerId) {
    try {
      const response = await fetch(url);
      const html = await response.text();

      this.renderGrid(html, gridContainerId);
    } catch (error) {
      console.error("Error fetching section on main search:", error);
    }
  }

  renderGrid(html, gridContainerId) {
    const newGridContent = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById(gridContainerId);
    if (!newGridContent) return;

    const gridContainer = document.getElementById(gridContainerId);
    gridContainer.insertAdjacentHTML("beforeend", newGridContent.innerHTML);
    new RevolutionAnimation(gridContainer);

    const newPaginationElement =
      newGridContent.querySelector(".infinite-scroll");
    document.dispatchEvent(new CustomEvent('update-favorites'));
    if (!newPaginationElement) return;
    new InfiniteScroll(`#${gridContainerId}`, `#${newPaginationElement.id}`);
  }

  toggleGrid(e) {
    const target = e.target.closest('[data-action="toggle-collection"]');
    const id = target.getAttribute("aria-controls");

    this.updatePath(id);

    /*     if (this.filterBar) {
          id.includes("product")
            ? this.filterBar.setAttribute("aria-hidden", "false")
            : this.filterBar.setAttribute("aria-hidden", "true");
        } */

    const gridsToHide = this.element.querySelectorAll(
      '.collection__grid[aria-hidden="false"]'
    );
    const gridToShow = this.element.querySelector(`#${id}`);

    gridsToHide.forEach((grid) => grid.setAttribute("aria-hidden", "true"));
    gridToShow.setAttribute("aria-hidden", "false");
  }

  toggleGridBasedOnUrl() {
    if (window.location.pathname.includes('/view/article-primary')) {
      this.element.querySelector('[aria-controls="collection-article"]')?.click();
    } else {
      this.element.querySelector('[aria-controls="collection-product"]')?.click();
    }
  }

  // Depending on where user refreshes, show them the type of results they were on before refreshing
  updatePath(id) {
    const url = new URL(window.location.href);
    const pathname = url.pathname;
    let updatedPathname = pathname;

    if (id.includes('article') && pathname.includes('/search') && !pathname.includes('/view/article-primary') && !window.location.href.includes("filter")) {
      updatedPathname = pathname.replace('/search', '/search/view/article-primary');
      window.history.replaceState({}, '', updatedPathname + url.search);
    } else if (!id.includes('article') && pathname.includes('/view/article-primary')) {
      updatedPathname = pathname.replace('/view/article-primary', '');
      window.history.replaceState({}, '', updatedPathname + url.search);
    }
  }
}
customElements.define("search-component", MainSearch);

class NotifyMe extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    document.body.appendChild(this.element);
  }

  connectedCallback() {
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.allNotifications = this.element.querySelectorAll(
      ".product-module__notify-action"
    );
    this.unsubscribedBox = this.element.querySelector('.product-module__notify-actions--unsubscribed');
    this.subscribedBox = this.element.querySelector('.product-module__notify-actions--subscribed');

    this.productId = document.querySelector(
      'form[data-product-form] [name="id"]'
    ).dataset.productid;

    this.bindEvents();
  }

  bindEvents() {
    this.onClickOutsideListener = this.closeNotifyMe.bind(this);

    this.delegateBody.on(
      "click",
      '[data-action="notify-open"]',
      this.openNotifyMe.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="subscribe"]',
      this.handleSubscribe.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="notify-close"]',
      this.closeNotifyMe.bind(this)
    );
  }

  handleSubscribe() {
    const email = this.element.querySelector('[name="notify_email"]').value;
    let promise = SI.create(email, selectedVariant.id, this.productId);

    if (email !== "" && email.includes("@")) {
      promise.then((st, data) => {
        let resp = SI.parseJSON(data);
        if (resp.status == "OK") {
          this.unsubscribedBox.setAttribute('aria-hidden', true);
          this.subscribedBox.setAttribute('aria-hidden', false);
        } else {
          this.showNotification("error");
        }
      });
    } else {
      this.showNotification("email-error");
    }
  }

  clearNotifications() {
    this.allNotifications.forEach((el) =>
      el.setAttribute("aria-hidden", "true")
    );
  }

  showNotification(string) {
    this.clearNotifications();

    let activeNotification;
    switch (string) {
      case "email-error":
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--email-error"
        );
        break;

      default:
        activeNotification = this.element.querySelector(
          ".product-module__notify-action--error"
        );
        break;
    }

    activeNotification.setAttribute("aria-hidden", "false");
  }

  openNotifyMe(e) {
    e.preventDefault();
    trapFocus(this.element);

    bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
    document.body.classList.add('scrollLock');
    this.element.setAttribute("aria-hidden", "false");
    this.pageOverlayElement.classList.add("is-visible");

    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
  }

  closeNotifyMe() {
    document.body.classList.remove('scrollLock');
    const onTransitionEnd = (e) => {
      if (e.propertyName === "opacity") {
        if (!document.body.classList.contains("scrollLock")) {
          bodyScrollLock.enableBodyScroll(this.element, bodyScrollLockOptions);
        }

        this.element.removeEventListener("transitionend", onTransitionEnd);
      }
    }

    this.element.addEventListener("transitionend", onTransitionEnd);

    this.element.setAttribute("aria-hidden", "true");

    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );

    this.unsubscribedBox.setAttribute('aria-hidden', false);
    this.subscribedBox.setAttribute('aria-hidden', true);

    this.clearNotifications();
  }
}

customElements.define("notify-me-popup", NotifyMe);

